<template>
  <div ref="sopWorkTaskBoard" style="position:relative" class="sop-work-task-board">
    <!--    <div class="sop-expand" style="right: 100px" @click="handleUnfold">-->
    <!--      <span>{{ isUnfold ? $t('Sop.PackUp') : $t('Sop.Unfold') }}</span>-->
    <!--      <i v-if="!isUnfold" class="el-icon-arrow-down" />-->
    <!--      <i v-else class="el-icon-arrow-up" />-->
    <!--    </div>-->
    <div class="sop-tab" :class="{mask: showLayer}">
      <!--【模板业务tab】-->
      <el-tabs :value="lob" :lazy="true" @input="onLobInput" @tab-click="lobChange(true)">
        <el-tab-pane
          v-for="(item) in businessTypes"
          :key="item.name"
          :label="item.label"
          :name="item.name"
          class="tab-pane-wrapper"
        >
          <!--          <template v-if="nodePriorityStatistics && nodePriorityStatistics.length>0">-->
          <template>
            <!--模板节点优先级统计-->
            <div style="display: flex; flex-wrap: wrap; background-color: white">
              <!--模板节点优先级统计信息-->
              <div
                v-for="(nodePriorityInfo, index) in nodePriorityStatistics"
                :key="index"
                style="border-style: solid; border-radius: 3%; width: 226px; height: 90px; margin-left: 10px; box-shadow: 0 0 5px #bad7ed; margin-top: 12px; margin-bottom: 12px; cursor: pointer;"
                :class="nodePriorityInfo.selected ? 'node-selected': 'node-default'"
                @click="nodeSelected(nodePriorityInfo)"
              >
                <div style="display: flex; align-items: center;">
                  <div class="tab-guide-item">
                    <img v-if="nodePriorityInfo.icon" :src="nodePriorityInfo.icon" width="22" height="22" alt="">
                    <div v-if="!nodePriorityInfo.icon">
                      <svg-icon v-if="lob === 'SI' || lob === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
                      <svg-icon v-else-if="lob === 'AI' || lob === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
                      <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
                    </div>
                  </div>
                  <span :title="enrichNodeTile(nodePriorityInfo)" class="underline-on-hover" style="align-items: center; margin-left: 13px; font-size: 15px; color: #3188cb; font-weight: bold; cursor: pointer;" @click.stop="nodeSelected(nodePriorityInfo)" v-html="enrichNodeName(nodePriorityInfo)" />
                </div>
                <div style="margin-top: 10px; ">
                  <span style="font-size: 15px;">{{ $t('CargoMsg.Cargo_High') }}</span>
                  <template>
                    <span v-if="nodePriorityInfo.enableHigh" title="" class="underline-on-hover" style="color: red; font-weight: bold; font-size: 15px; cursor: pointer;" @click.stop="nodeSelected(nodePriorityInfo, PRIORITY_HIGH.code)">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_HIGH.code) }}</span>
                    <span v-else title="" style="color: red; font-weight: bold; font-size: 15px;">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_HIGH.code) }}</span>
                  </template>
                  <span style="margin-left: 10px; font-size: 15px;">{{ $t('CargoMsg.Cargo_Medium') }}</span>
                  <template>
                    <span v-if="nodePriorityInfo.enableMedium" class="underline-on-hover" style="color: #e4a952; font-weight: bold; font-size: 15px; cursor: pointer;" @click.stop="nodeSelected(nodePriorityInfo, PRIORITY_MEDIUM.code)">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_MEDIUM.code) }}</span>
                    <span v-else style="color: #e4a952; font-weight: bold; font-size: 15px;">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_MEDIUM.code) }}</span>
                  </template>
                  <span style="margin-left: 10px; font-size: 15px;">{{ $t('CargoMsg.Cargo_Low') }}</span>
                  <template>
                    <span v-if="nodePriorityInfo.enableLow" class="underline-on-hover" style="color: #0bae5b; font-weight: bold; font-size: 15px; cursor: pointer;" @click.stop="nodeSelected(nodePriorityInfo, PRIORITY_LOW.code)">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_LOW.code) }}</span>
                    <span v-else style="color: #0bae5b; font-weight: bold; font-size: 15px;">{{ enrichNodeCount(nodePriorityInfo, PRIORITY_LOW.code) }}</span>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--    &lt;!&ndash;【刷新时间】&ndash;&gt;-->
    <!--    <span-->
    <!--      style="position: absolute; right: 180px; top: -10px; color: #989999"-->
    <!--    >-->
    <!--      {{ $t('Sop.LastRefreshTime') + ':' + refreshTime }}-->
    <!--    </span>-->
    <div style="position: absolute; right: 0; top: 0">
      <!--【SOP面板无数据时，自动隐藏】-->
      <el-checkbox v-model="sopNodeNoDataHide" style="margin-right: 10px" @change="sopNodeNoDataHideChangeHandle">{{ $t('CargoMsg.Cargo_SOPPanelNoDataHide') }}</el-checkbox>
      <!--【模板节点合并显示】-->
      <span
        v-if="templates && templates.length > 1 && !selectedTemplateMap.get(lob)"
        style="color: #989999"
      >
        {{ $t('CargoMsg.Cargo_TemplateNodeMergeShow') }}
      </span>
      <span v-if="selectedTemplateMap.get(lob)" style="margin: 0px 5px;color: #1F75D5;">{{ selectedTemplateMap.get(lob) ? selectedTemplateMap.get(lob)['templateName'] : null }}</span>
      <el-popover v-model="popVisible" placement="bottom-end">
        <el-button slot="reference" type="primary">
          {{ $t('Message.SelectTemplate') }}
          <i class="el-icon-arrow-down" style="color: #CCCCCC;" />
        </el-button>
        <!--【模板选择弹框】-->
        <el-table :data="templates" border :row-class-name="onRowClassName">
          <el-table-column :label="$t('Template.TemplateName')" width="150">
            <template slot-scope="{row}">
              <div style="cursor: pointer;" @click="onTemplateClick(row)">{{ row.templateName }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('CargoMsg.Cargo_DefaultOrNot')">
            <template slot-scope="{row}">
              <el-checkbox :value="row.homepageDisplayOnUserWt" @input="val=>onCheckInput(row,val)" />
            </template>
          </el-table-column>
        </el-table>
      </el-popover>
    </div>
    <!--分割线-->
    <el-divider style="height: 2px; background-color: #E4E7ED; margin-top: 15px; margin-bottom: 15px" />
    <sop-filter ref="sopFilter" :lob="lob" :sop-templates="templates" :is-sales-for-szfs="isSalesForSzfs" :default-levels="toNumArray( defaultLevels)" style="margin-bottom: 15px;display: flex" @search="handleSearch">
      <!--      &lt;!&ndash;【节点业务列表 高优先级 按钮】&ndash;&gt;-->
      <!--      <span style="margin-left: 30px;" :class="showPriorityHighClass" @click="priorityHighClick">{{ $t('CargoMsg.Cargo_PriorityHigh') }}</span>-->
      <!--【节点业务列表 更多筛选 按钮】-->
      <el-button slot="filter" no="moreFilter" type="primary" @click="filterDialog.visible = true;">{{ $t('CargoMsg.Cargo_MoreFilters') }}</el-button>
      <!--【状态修改 按钮】-->
      <el-button slot="other" no="editSopStatus" type="success" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
      <!--【节点 操作按钮】-->
      <template slot="other">
        <div v-for="(tenantInstruction, index) in tenantInstructions" :key="index">
          <el-button
            v-if="PLATFORM_INSTRUCTION_CODE_JUMP_PAGE.code !== tenantInstruction.platformInstructionCode"
            :disabled="(PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code === tenantInstruction.platformInstructionCode
              || PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code === tenantInstruction.platformInstructionCode)
              && selectedRowsCount !== 0 && (selectedRowsCount !== 1 || !selectedRow.instructionUuids || selectedRow.instructionUuids.indexOf(tenantInstruction.uuid) <= -1)"
            type="primary"
            style="margin-left: 5px"
            @click="batchInstructionClick(tenantInstruction)"
          >
            {{ ColumnUtils.instructionNameLabelFunc(tenantInstruction) }}
          </el-button>
        </div>
      </template>
      <el-checkbox slot="other" v-model="collapseList" :disabled="onlyShowSlave" style="line-height: 28px;margin-left: 5px;margin-right: 10px;" @change="onCollapseListChange">{{ $t('CargoMsg.Cargo_CollapseList') }}</el-checkbox>
      <el-checkbox slot="other" v-model="onlyShowSlave" :disabled="collapseList" style="line-height: 28px;margin-left: 5px;margin-right: 10px;" @change="onOnlyShowSlaveChange">{{ $t('CargoMsg.DisplayReceiptsOnly') }}</el-checkbox>
    </sop-filter>
    <!--【节点业务列表】（显示列不一样，所以需要定义多个grid，hide属性不支持动态的，初始化表格的时候就确定了）-->
    <cargo-ag-grid
      v-if="lob === 'SE'"
      key="seGrid"
      config-module="1100000053"
      :grid-options="se.gridOptions"
      :column-defs="seColumnDefs"
      :grid-params.sync="gridParams"
      :row-data="finalJobs"
      :check-sub-record="false"
      :check-main-record="false"
      :deselect-main-record="false"
      :deselect-sub-record="false"
      style="height: 470px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-ag-grid
      v-if="lob === 'SI'"
      key="siGrid"
      config-module="1100000013"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :grid-params.sync="gridParams"
      :row-data="finalJobs"
      style="height: 470px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-ag-grid
      v-if="lob === 'AE' || lob === 'AI'"
      key="aeAiAiGrid"
      config-module="1100000023"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :grid-params.sync="gridParams"
      :row-data="finalJobs"
      style="height: 470px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-ag-grid
      v-if="lob === 'RE' || lob === 'RI'"
      key="reRiGrid"
      config-module="1100000033"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :grid-params.sync="gridParams"
      :row-data="finalJobs"
      style="height: 470px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-ag-grid
      v-if="lob === 'IE'"
      key="ieGrid"
      config-module="1100000043"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :grid-params.sync="gridParams"
      :row-data="finalJobs"
      style="height: 470px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <!--节点分页-->
    <div style="min-height: 50px; height: 100%;position: relative">
      <div style="position: absolute; right: 5px;">
        <cargo-pagination
          config-module="100000005"
          :total="filter.total || 0"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="loadData"
        />
      </div>
    </div>
    <!--【模板更多业务弹窗】-->
    <sop-more-filter-dialog
      v-show="filterDialog.visible"
      ref="filterDialog"
      :visible="filterDialog.visible"
      :sop-templates="templates"
      :lob="lob"
      :operation-date-query-search="operationDateQuerySearch"
      :default-levels="defaultLevels"
      @close="filterDialog.visible=false"
      @search="handleSearch"
    />

    <!-- 状态修改弹窗 -->
    <dashboard-state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :filter="stateDialog.filter"
      :tracking-list="stateDialog.trackingList"
      @callback="loadData(true)"
    />

    <!--形式分单弹窗-->
    <sop-virtual-hbl-dialog
      v-if="virtualHBLDialog.visible"
      :visible.sync="virtualHBLDialog.visible"
      :jobs="virtualHBLDialog.jobs"
      :job="virtualHBLDialog.job"
      @instructionCallback="instructionCallback"
    />

    <!-- 【委托拼箱】发送目的港代理邮件 选择弹窗 -->
    <destination-agent-select-dialog
      v-if="destinationAgentSelectDialog.visible"
      :visible.sync="destinationAgentSelectDialog.visible"
      :row-data="destinationAgentSelectDialog.rowData"
      :total="destinationAgentSelectDialog.total"
      :job-count="destinationAgentSelectDialog.jobCount"
      @callback="onSelectDestinationAgent"
    />

    <!-- 【委托拼箱 or 自拼箱】发送目的港代理邮件 校验弹窗 -->
    <checking-send-destination-agent-window
      v-if="checkingSendDestinationAgentWindow.visible"
      :visible.sync="checkingSendDestinationAgentWindow.visible"
      :is-pass="checkingSendDestinationAgentWindow.isPass"
      :master-info="checkingSendDestinationAgentWindow.masterInfo"
      :slave-info="checkingSendDestinationAgentWindow.slaveInfo"
      :row-data="checkingSendDestinationAgentWindow.rowData"
      :show-next="checkingSendDestinationAgentWindow.showNext"
      :match-instruction-tip="checkingSendDestinationAgentWindow.matchInstructionTip"
      @next="sendDestinationPortAgentNext"
    />

    <!-- 【委托拼箱】发送目的港代理邮件 弹窗 -->
    <send-destination-port-agent-email-multi-dialog
      v-if="sendDestinationPortAgentEmailMultiDialog.visible"
      :visible.sync="sendDestinationPortAgentEmailMultiDialog.visible"
      :job="sendDestinationPortAgentEmailMultiDialog.job"
      :jobs="sendDestinationPortAgentEmailMultiDialog.jobs"
      :destination-agent="sendDestinationPortAgentEmailMultiDialog.destinationAgent"
      :mail-template-uuid="sendDestinationPortAgentEmailMultiDialog.mailTemplateUuid"
      :push-link="sendDestinationPortAgentEmailMultiDialog.pushLink"
      :tenant-instruction="currentTenantInstruction"
      @instructionCallback="instructionCallback"
    />

    <!-- 【自拼箱】发送目的港代理邮件 弹窗 -->
    <send-destination-port-agent-email-dialog
      v-if="lclSendDestinationPortAgentEmailDialog.visible"
      :visible.sync="lclSendDestinationPortAgentEmailDialog.visible"
      :job="lclSendDestinationPortAgentEmailDialog.job"
      :mail-template-uuid="lclSendDestinationPortAgentEmailDialog.mailTemplateUuid"
      :push-link="lclSendDestinationPortAgentEmailDialog.pushLink"
      :exchange-agent-data="lclSendDestinationPortAgentEmailDialog.exchangeAgentData"
      :tenant-instruction="currentTenantInstruction"
      @instructionCallback="instructionCallback"
    />

    <!-- 【自拼箱】换单代理选择 弹窗 -->
    <exchange-agent-select-dialog
      :visible.sync="exchangeAgentSelectDialog.visible"
      :job-uuid="exchangeAgentSelectDialog.jobUuid"
      :exchange-agents="exchangeAgentSelectDialog.exchangeAgents"
      @callback="onSelectExchangeAgent"
    />

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :upload-source="UPLOAD_SOURCE_FILE_HISTORY.code"
      :lob="cloudFile.lob"
      :job-uuids="cloudFile.jobUuids"
      :upload-to-job-uuids-sync="true"
      :tenant-instruction-uuid="currentTenantInstruction.uuid"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :can-change-file-category="false"
      @uploadSuccess="instructionCallBackByUploadFile"
    />

    <!-- 打印报表对话框 -->
    <!-- @updateDocCfmState="updateDocCfmState" -->
    <cargo-template-selector-dialog
      v-if="templateSelectorDialog.visible"
      ref="templateSelectorSupportMultiTypesDialog"
      :visible.sync="templateSelectorDialog.visible"
      :template-uuids="templateSelectorDialog.templateUuids"
      :document-type-uuid="templateSelectorDialog.documentTypeUuid"
      :lob="templateSelectorDialog.lob"
      :job="templateSelectorDialog.job"
      :data="templateSelectorDialog.data"
      :job-uuid-list="templateSelectorDialog.jobUuidList"
      :call-by-instruction="true"
      @instructionCallback="instructionCallback"
    />

    <!--操作指令日志-->
    <instruction-records-dialog
      v-if="instructionRecordsDialog.visible"
      :visible.sync="instructionRecordsDialog.visible"
      :row-data="instructionRecordsDialog.rowData"
    />
    <!-- 一键发送窗口(用于指令处理) -->
    <one-click-send-window ref="oneClickSendWindow" :file-type-caps-map="fileTypeCapsMap" @instructionCallback="onInstructionCallback" />
    <!-- 上传文件(用于指令处理) -->
    <upload-file-window ref="uploadFileWindow" @instructionCallback="onInstructionCallback" />
    <!-- 打印文件(用于指令处理) -->
    <print-file-window ref="printFileWindow" @instructionCallback="onInstructionCallback" />
    <!-- 修改SOP状态(用于指令处理) -->
    <modify-state-window ref="modifyStateWindow" @callback="loadData(true)" />
    <!-- 自定义表单窗口 -->
    <custom-form-window ref="customFormWindow" @instructionCallback="onInstructionCallback" />
    <!-- 更新业务状态窗口 -->
    <update-job-state-window ref="updateJobStateWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>
<script>
import {
  getLobsWt,
  getNodePriorityJobCountWt,
  getPriorityJobsWt,
  getTemplatesWt
} from '@/api/sop'
import {
  AE, AI,
  BUSINESS_TYPES, IE, INSTRUCTION_ACTION_BATCH, INSTRUCTION_ACTION_SINGLE, INSTRUCTION_TEMPLATE_TYPE_MAP,
  PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT, PLATFORM_INSTRUCTION_CODE_JUMP_PAGE,
  PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT,
  PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT, PLATFORM_INSTRUCTION_CODE_PRINT_FILE,
  PLATFORM_INSTRUCTION_CODE_UPLOAD_FILE,
  PLATFORM_INSTRUCTION_CODE_VIRTUAL_HBL,
  PLATFORM_INSTRUCTION_CODE_UPDATE_SOP_NODE_STATUS,
  PRIORITY_HIGH,
  PRIORITY_LOW,
  PRIORITY_MEDIUM, RE, RI, SE,
  SEND_DESTINATIOIN_PORT_AGENT,
  SEND_PACKAGE_AGENT, SI, UPLOAD_SOURCE_FILE_HISTORY,
  PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM,
  PLATFORM_INSTRUCTION_CODE_UPDATE_JOB_STATE,
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
  JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL, JOB_BOOKING_STATE_VALID_FAIL
} from '@/class/cargo/model/parameters/SystemConstants'
import { mapGetters } from 'vuex'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { updateTrackingTemplateUuidsWt } from '@/api/user'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import SopMoreFilterDialog from '@/views/dashboard/admin/components/SopMoreFilterDialog'
import SopFilter from '@/views/dashboard/admin/components/SopFilter'
import dateUtils from '@/utils/dateUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import { formatHourMinute } from '@/utils'
import DashboardStateDialog from '@/components/Cargo/Job/DashboardStateDialog'
import { getTrackingListByLob } from '@/api/seaExport/seaExportJob'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import SopVirtualHblDialog from '@/views/dashboard/admin/components/sopVirtualHbl/sopVirtualHblDialog.vue'
import OperationRender from '@/components/OperationRender'
import InstructionBtns from '@/views/dashboard/admin/components/InstructionBtns'
import InstructionRecordsDialog from '@/views/dashboard/admin/components/InstructionRecordsDialog'
import { generateInstructionRecord, getInstructionRecordsByJobUuid } from '@/api/sysManage/baseConfig/instruction'
import {
  checkSendDestinationPortAgent,
  checkSendDestinationPortAgentMulti
} from '@/api/sysManage/baseConfig/checkRuleConfig'
import lodash from 'lodash'
import DestinationAgentSelectDialog from '@/components/Cargo/Job/booking/tabs/DestinationAgentSelectDialog'
import CheckingSendDestinationAgentWindow
  from '@/components/Cargo/Job/CheckingManager/CheckingSendDestinationAgentWindow'
import SendDestinationPortAgentEmailMultiDialog from '@/components/Cargo/Job/SendDestinationPortAgentEmailMultiDialog'
import { DocumentCategory } from '@/class/model/sys/DocumentCategory'
import StrUtils from '@/utils/StrUtils'
import SendDestinationPortAgentEmailDialog from '@/components/Cargo/Job/SendDestinationPortAgentEmailDialog'
import { getExChangeAgentsByJobUuid } from '@/api/booking/job'
import ExchangeAgentSelectDialog from '@/components/Cargo/Job/booking/tabs/ExchangeAgentSelectDialog'
import { Job } from '@/class/model/booking/Job'
import { batchUpdateTrackingForDocumentType } from '@/api/fileHistory'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'
import OneClickSendWindow from '@/components/Cargo/Job/instructionManager/oneClickSendWindow'
import uploadFileWindow from '@/components/Cargo/Job/instructionManager/uploadFileWindow'
import printFileWindow from '@/components/Cargo/Job/instructionManager/printFileWindow'
import { cache, cacheName } from '@/utils/cacheManager'
import ModifyStateWindow from '@/components/Cargo/Job/instructionManager/modifyStateWindow'
import CustomFormWindow from '@/components/Cargo/Job/customFormWindow'
import UpdateJobStateWindow from '@/components/Cargo/Job/instructionManager/updateJobStateWindow'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { getUserInfo } from '@/utils/auth'
import { getPersonQueryConfig, savePersonQueryConfig } from '@/api/commonComponent'

// 页面缓存信息
const pageCache = {
  nodePriorityInfoSelected: null
}

export default {
  name: 'SopWorkTaskBoard',
  components: {
    InstructionRecordsDialog, DestinationAgentSelectDialog, CheckingSendDestinationAgentWindow, SendDestinationPortAgentEmailMultiDialog,
    SopVirtualHblDialog, DashboardStateDialog, SopMoreFilterDialog, SopFilter, InstructionBtns, SendDestinationPortAgentEmailDialog, ExchangeAgentSelectDialog,
    cargoCloudFileUpload, cargoTemplateSelectorDialog, OneClickSendWindow, uploadFileWindow, printFileWindow, ModifyStateWindow, CustomFormWindow, UpdateJobStateWindow },
  props: {
    showLayer: {
      type: Boolean,
      default: false
    },
    sopWorkTaskBoardLob: {
      type: String,
      default: ''
    },
    operationDateQuerySearch: { type: Boolean, default: false }, // 子应用操作日期查询条件、显示列
    operationDateQueryColumn: { type: Boolean, default: false }
    // ,
    // sopWorkTaskBoardLob: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      sopNodeNoDataHide: false,
      sopDashboardConfig: null,
      isFirst: true,
      PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT, PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT,
      UPLOAD_SOURCE_FILE_HISTORY, PLATFORM_INSTRUCTION_CODE_JUMP_PAGE, PLATFORM_INSTRUCTION_CODE_UPDATE_SOP_NODE_STATUS,
      PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM,
      ColumnUtils,
      isUnfold: true,
      businessTypes: [],
      nodePriorityInfoSelected: null, // 【选中的节点】
      allNodePriorityStatistics: [], // 所有【各个节点】优先级个数统计
      nodePriorityStatistics: [], // 【各个节点】优先级个数统计

      // defaultTemplateName: '', // 选中的【模板名称】
      // defaultTemplateKeyMap: new Map(), // 选中的【模板uuid】

      templatesMap: new Map(), // 所有【模板】
      templates: [], // 当前业务tab的【模板】
      defaultTemplateMap: new Map(), // 默认的【模板】
      selectedTemplateMap: new Map(), // 选中的【模板】
      // selectedTemplate: null, // 选中的【模板】
      gridParams: {},
      selectedRowsCount: 0,
      selectedRow: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        frameworkComponents: {
          RouterAndPrintRenderer
        }, // 多选（勾选框触发）
        onRowSelected: (event) => {
          this.selectedRowsCount = event.api.getSelectedRows().length
          if (this.selectedRowsCount > 0) {
            this.selectedRow = event.api.getSelectedRows()[0]
          } else {
            this.selectedRow = {}
          }
        }
      },
      jobs: [],
      tenantInstructions: [], // 操作指令
      gridApi: null,
      popVisible: false, // 模板选择框显示控制
      stateDialog: { // 状态修改
        visible: false,
        rows: [],
        filter: {},
        trackingList: []
      },
      filterDialog: {
        visible: false
      },
      filter: {
        lob: this.lob,
        branchId: 0,
        trackingTemplateUuid: null,
        code: null,
        businessStartTime: dateUtils.formatStandardDate(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 90)),
        businessEndTime: null,
        total: 0,
        pageNum: 1,
        pageSize: 15,
        showPriorityHigh: true
      },
      lob: '',
      autoTimer: null,
      time: 3600000, // 自动刷新 (一小时刷新一次)
      PRIORITY_LOW: PRIORITY_LOW,
      PRIORITY_MEDIUM: PRIORITY_MEDIUM,
      PRIORITY_HIGH: PRIORITY_HIGH,
      documentManage: new DocumentManage(),
      virtualHBLDialog: { // 形式分单
        visible: false,
        jobs: [],
        job: ''
      },
      sendDestinationPortAgentEmailMultiDialog: {
        visible: false,
        pushLink: ''
      },
      checkingSendDestinationAgentWindow: {
        visible: false
      },
      destinationAgentSelectDialog: {
        visible: false,
        rowData: [],
        total: 0,
        jobCount: 0,
        jobsGroupByDestinationAgent: null
      },
      lclSendDestinationPortAgentEmailDialog: {
        visible: false,
        fileList: [],
        pushLink: ''
      },
      exchangeAgentSelectDialog: {
        visible: false,
        jobUuid: '',
        exchangeAgents: [],
        selectData: null
      },
      instructionRecordsDialog: {
        visible: false,
        rowData: []
      },
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE'
      },
      templateSelectorDialog: {
        visible: false,
        data: {}
      },
      currentTenantInstruction: {},
      fileTypeCapsMap: new Map(), // 按照大写字母匹配
      // refreshTime: ''
      disabledAutoRefresh: false, // 是否禁用自动刷新
      keepSelectedNode: false, // 是否保持选中节点
      keepQueryCondition: false, // 是否保持查询条件
      resetQueryOnTemplateSwitch: false, // 不根据查询结果数量显示，切换模板时重置查询条件
      defaultLevels: '', // 默认显示的优先级（多个，以逗号隔开）
      se: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          frameworkComponents: {
            RouterAndPrintRenderer
          }, // 多选（勾选框触发）
          onRowSelected: (event) => {
            this.selectedRowsCount = event.api.getSelectedRows().length
            if (this.selectedRowsCount > 0) {
              this.selectedRow = event.api.getSelectedRows()[0]
            } else {
              this.selectedRow = {}
            }
          },
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path ? data.path.split(',') : []
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              checkbox: params => {
                const currentJob = params.data
                if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                  return false
                }
                return true
              },
              innerRenderer: params => {
                const currentJob = params.data
                if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                  const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                  return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
                }
                const onCellJobNoClickMethod = this.documentManage.getPath('onCellJobNoClick')
                return `<a href="javascript:void(0)" style="color: rgb(0, 0, 255);" onclick="${onCellJobNoClickMethod}(event, '${params.data.uuid}')">${params.value}</a>`
              }
            }
          }
        }
      },
      collapseList: false, // 收起列表
      onlyShowSlave: false // 仅显示小票
    }
  },
  watch: {
    // lob(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     getNodePriorityJobCountWt({ lob: this.lob, branchId: this.currentOfficeId, trackingTemplateUuid: this.defaultTemplateKeyMap.get(this.lob) }).then(res => {
    //       this.nodePriorityStatistics = res.data
    //     })
    //   }
    // }
    currentOfficeId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.refreshPage()
      }
    },
    // sopWorkTaskBoardLob(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.lob = newVal
    //   }
    // }
    sopWorkTaskBoardLob: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.lob = newVal
        }
      }
    },
    lob: {
      immediate: true,
      handler(newVal) {
        this.loadSopDashboardConfig()
        this.collapseList = LocalStorageUtilsNew.getConfiguration('SopWorkTaskBoard_collapseList_' + this.lob) || false
        this.onCollapseListChange()
        this.onlyShowSlave = LocalStorageUtilsNew.getConfiguration('SopWorkTaskBoard_onlyShowSlave_' + this.lob) || false
        this.onOnlyShowSlaveChange()
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentOfficeId'
    ]),
    curOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isSalesForSzfs() { // 深圳丰收销售专用
      return cache.config && String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 32, checkboxSelection: true, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true, lockPosition: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationInstructions'),
          field: 'instructionBtns',
          colId: 'instructionBtns',
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: InstructionBtns,
          cellRendererParams: {
            tenantInstructions: this.tenantInstructions,
            instructionClick: this.instructionClick
          },
          lockPosition: true
        },
        { // 主票单号
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          field: 'masterJobNo',
          colId: 'masterJobNo',
          width: 100,
          cellRendererSelector: (params) => {
            return ColumnUtils.routeNameByJobLobFun(params, 'lob', 'masterJobNo', true)
          }
        },
        { // 业务编号
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 100,
          cellRendererSelector: (params) => {
            return ColumnUtils.routeNameByJobLobAndInstructionFun(params, 'lob', 'jobNo', true, this.tenantInstructions, this.instructionClick)
          }
        },
        { // 委托单位
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 140,
          cellRenderer: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        { // 整拼类型/操作模式/委托类型/订单类型
          headerName: ['SE', 'SI'].includes(this.lob) ? this.$t('CargoMsg.Cargo_FLCLType') : ['AE', 'AI'].includes(this.lob) ? this.$t('SeaExport.OperateType') : ['RE', 'RI'].includes(this.lob) ? this.$t('RailwayExport.containerLoadType') : this.$t('CargoMsg.Cargo_OrderType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          width: 200,
          cellRenderer: (params) => {
            let msg = ''
            if (params.value) {
              const arr = params.value.split(',')
              const result = []
              const cargoTypes = SopUtil.getFLclType(params.data.lob)
              if (cargoTypes) {
                for (const val of arr) {
                  const value = cargoTypes.find(cargoType => String(cargoType.code) === String(val))
                  if (value) {
                    result.push(this.isZh ? value.chineseName : value.englishName)
                  }
                }
              }
              msg = result.join(',')
            }
            return msg
          }
        },
        // 主单号/运单号/CMR号
        {
          headerName: ['RI', 'RE'].includes(this.lob) ? this.$t('RailwayExport.mbl') : ['IE'].includes(this.lob) ? this.$t('Integrated.Mbl') : this.$t('SeaExport.Mbl2'),
          field: 'mblNo',
          colId: 'mblNo',
          width: 100
        },
        { // 起运港/始发站/（综合物流：起运港/起运地）
          headerName: ['RE', 'RI'].includes(this.lob) ? this.$t('CargoMsg.Cargo_DepartureStation') : this.lob === 'IE' ? this.$t('CargoMsg.Cargo_PortPlaceOfDeparture') : this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'loadingPortCode',
          width: 100,
          cellRenderer: (params) => {
            let type = ''
            if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              type = TYPE_NAMES.basic_data_Airport
            } else {
              type = TYPE_NAMES.basic_data_Seaport
            }
            return ColumnUtils.resolveColumnLabel(type, 'code', params.value, 'englishName')
          }
        },
        { // 操作
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'opId', field: 'opId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { // 销售
          headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'salesId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { // 单证
          headerName: this.$t('SeaExport.Documents'),
          field: 'dcId',
          colId: 'dcId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { // 客服
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csrId',
          colId: 'csrId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Etd'), field: 'etd', colId: 'etd', width: 90,
          cellRenderer: (params) => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', colId: 'eta', width: 90,
          cellRenderer: (params) => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          colId: 'quantityContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          suppressColumnsToolPanel: this.isSalesForSzfs
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          suppressColumnsToolPanel: this.isSalesForSzfs
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson'),
          field: 'planner',
          colId: 'planner',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionRecords'),
          field: '',
          colId: '',
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_QueryInstructionRecords'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.queryInstructionRecords(params)
                },
                visible: (params) => true
              }
            ]
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_LatestInstructionRecord'),
          field: 'latestInstructionRecord',
          colId: 'latestInstructionRecord',
          cellRenderer: (params) => {
            return ColumnUtils.latestInstructionRecordLabelFunc(params.data.latestInstructionRecord)
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.latestInstructionRecordLabelFunc(params.data.latestInstructionRecord)
          }
        }

        // ,
        // { // 箱量描述
        //   headerName: this.$t('SeaExport.ContainerDescription'),
        //   field: 'containerDesc',
        //   colId: 'containerDesc',
        //   valueFormatter: (params) => {
        //     return ColumnUtils.containerDescLabelFunc(params.value)
        //   },
        //   hide: true,
        //   initialWidth: 150,
        //   suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI' || this.lob === 'RE' || this.lob === 'RI')
        // },
        // { // 船公司/航空公司
        //   headerName: ['SE', 'SI'].includes(this.lob) ? this.$t('SeaExport.ShippingCompany') : this.$t('SeaExport.AirlineCompany'),
        //   field: 'carrierId',
        //   colId: 'carrierId',
        //   hide: true,
        //   cellRenderer: (params) => {
        //     return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
        //   },
        //   width: 200,
        //   suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI' || this.lob === 'AE' || this.lob === 'AI')
        // },
        // { // 业务日期
        //   headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
        //   field: 'businessDate',
        //   colId: 'businessDate',
        //   hide: true,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.dateLabelFunc(params.value)
        //   },
        //   width: 200,
        //   suppressColumnsToolPanel: !(this.lob === 'IE')
        // }
      ]
      if (this.lob === 'SE' || this.lob === 'SI') {
        columnDefs.push(
          // 关单号
          {
            headerName: this.$t('SeaExport.SoNo'),
            field: 'soNo',
            colId: 'soNo',
            width: 100
          }
        )
      }
      if (this.lob !== 'IE') {
        columnDefs.push(
          { // 目的港/目的站
            headerName: ['RE', 'RI'].includes(this.lob) ? this.$t('CargoMsg.Cargo_DestinationStation') : this.$t('CargoMsg.Cargo_DestinationPort'),
            field: 'destinationPortCode',
            width: 100,
            cellRenderer: (params) => {
              let type = ''
              if (params.data.lob === 'AE' || params.data.lob === 'AI') {
                type = TYPE_NAMES.basic_data_Airport
              } else {
                type = TYPE_NAMES.basic_data_Seaport
              }
              return ColumnUtils.resolveColumnLabel(type, 'code', params.value, 'englishName')
            }
          }
        )
      }
      if (this.lob === 'IE') {
        columnDefs.push(
          { // （综合物流：卸货港/卸货地）
            headerName: this.$t('CargoMsg.Cargo_PortPlaceOfDischarge'),
            field: 'dischargingPortCode',
            width: 100,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
            }
          }
        )
        columnDefs.push(
          { // 业务日期
            headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
            field: 'businessDate',
            colId: 'businessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 200
          }
        )
      }
      if (this.lob === 'RE' || this.lob === 'RI') {
        columnDefs.push(
          { // 过境站
            headerName: this.$t('RailwayExport.transitStation'),
            field: 'transitStation',
            width: 100,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
            }
          }
        )
      }
      if (this.lob === 'SE' || this.lob === 'SI' || this.lob === 'RE' || this.lob === 'RI') {
        columnDefs.push(
          { // 船名/班车
            headerName: ['SE', 'SI'].includes(this.lob) ? this.$t('CargoMsg.Cargo_ChineseFirstVesselName') : this.$t('RailwayExport.vessel'),
            field: 'vessel',
            colId: 'vessel',
            width: 100
          }
        )
        columnDefs.push(
          { // 箱量描述
            headerName: this.$t('SeaExport.ContainerDescription'),
            field: 'containerDesc',
            colId: 'containerDesc',
            valueFormatter: (params) => {
              return ColumnUtils.containerDescLabelFunc(params.value)
            },
            initialWidth: 150
          }
        )
      }

      if (this.lob === 'SE' || this.lob === 'SI' || this.lob === 'AE' || this.lob === 'AI') {
        columnDefs.push(
          { // 航次/航班
            headerName: this.$t('CargoMsg.Cargo_VoyageFlight'),
            field: 'voyageFlight',
            colId: 'voyageFlight',
            width: 100
          }
        )
        columnDefs.push(
          { // 船公司/航空公司
            headerName: ['SE', 'SI'].includes(this.lob) ? this.$t('SeaExport.ShippingCompany') : this.$t('SeaExport.AirlineCompany'),
            field: 'carrierId',
            colId: 'carrierId',
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
            },
            width: 200
          }
        )
      }
      if (this.lob === 'SE') {
        columnDefs.push(
          {
            headerName: this.$t('SeaExport.ActualDateOfLeavingBerth'),
            field: 'actualUnBerthPlanDate',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.HBLDateOfIssue'),
            field: 'hblSignDateBL',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.HBLBlType'),
            field: 'hblReleaseType',
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.HBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(params.value))
            },
            hide: true
          },
          {
            headerName: this.$t('SeaExport.HBLCheckingStatus'),
            field: 'hblCfmState',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.cfmStatusLabelFunc(params.value || 0)
            },
            hide: true
          },
          {
            headerName: this.$t('SeaExport.HBLIssueBillLading'),
            field: 'hblBliStatus',
            width: 150,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.constantsBillLadingIssuingStatus(params.value || 0)
            }
          }
        )
        // // 获取当前节点的信息，如果 生成单据条件 === 1（生成形式分单） 就获取 按钮名称【形式分单】
        // if (this.nodePriorityInfoSelected && this.nodePriorityInfoSelected.buttonName === 1) {
        //   const buttonName = this.$constantI18n('buttonName').find(p => p.value === this.nodePriorityInfoSelected.buttonName)
        //   if (buttonName) {
        //     // 功能操作 显示列
        //     columnDefs.push(
        //       {
        //         headerName: this.$t('SeaExport.FunctionalOperation'),
        //         field: 'buttonName',
        //         width: 100,
        //         cellRenderer: (params) => {
        //           // 获取按钮名称
        //           const text = buttonName.name
        //           // 获取虚拟HBL窗口
        //           const virtualHblWindowMetch = this.documentManage.getPath('virtualHBLWindow')
        //           return `<a href="javascript:void(0)" style="border-bottom: 1px solid;color: #4A86C6;" onclick="${virtualHblWindowMetch}(event, '${params.data.jobUuid}')">${text}</a>`
        //         }
        //       }
        //     )
        //   }
        // }else {
        //   columnDefs.push(
        //     {
        //       headerName: this.$t('SeaExport.FunctionalOperation'),
        //       field: 'buttonName',
        //       width: 100
        //     }
        //   )
        // }
      }
      columnDefs.push({
        headerName: this.$t('SeaExport.ContainerNo'),
        field: 'containerNos',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SealNo'),
        field: 'sealNos',
        hide: true,
        width: 150
      })
      // 操作日期
      if (this.operationDateQueryColumn) {
        columnDefs.push({
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        })
      }
      return columnDefs
    },
    showPriorityHighClass() {
      return this.filter.showPriorityHigh ? 'select-data' : 'no-select-data'
    },
    filterDialogRefName() {
      if (this.lob === 'SE') {
        return 'sopFilter'
      }
      return 'filterDialog'
    },
    seColumnDefs() {
      const result = [{
        headerName: this.$t('CargoMsg.Cargo_OperationInstructions'),
        field: 'instructionBtns',
        colId: 'instructionBtns',
        width: 400,
        cellStyle: { textAlign: 'center' },
        cellRendererFramework: InstructionBtns,
        cellRendererParams: {
          tenantInstructions: this.tenantInstructions,
          instructionClick: this.instructionClick
        },
        lockPosition: true
      },
      { // 主票单号
        headerName: this.$t('SeaExport.MasterBusinessNo'),
        field: 'masterJobNo',
        colId: 'masterJobNo',
        width: 100,
        cellRendererSelector: (params) => {
          return params.value ? ColumnUtils.routeNameByJobLobFun(params, 'lob', 'masterJobNo', true) : ''
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_InstructionRecords'),
        field: '',
        colId: '',
        width: 400,
        cellStyle: { textAlign: 'center' },
        cellRendererFramework: OperationRender,
        cellRendererParams: {
          operations: [
            {
              title: this.$t('CargoMsg.Cargo_QueryInstructionRecords'),
              type: 'primary',
              cssStyle: 'text-decoration: underline;',
              onClick: data => {
                this.queryInstructionRecords(data)
              },
              visible: data => data.dataType === '1' || data.dataType === '2'
            }
          ]
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_LatestInstructionRecord'),
        field: 'latestInstructionRecord',
        colId: 'latestInstructionRecord',
        cellRenderer: (params) => {
          return ColumnUtils.latestInstructionRecordLabelFunc(params.data.latestInstructionRecord)
        },
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.latestInstructionRecordLabelFunc(params.data.latestInstructionRecord)
        }
      }, {
        headerName: this.$t('SeaExport.HBLDateOfIssue'),
        field: 'hblSignDateBL',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.SealNo'),
        field: 'sealNos',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ConsignationRelationNumber'),
        colId: 'trustFromJob',
        field: 'trustFromJob',
        width: 150
      }, {
        headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
        colId: 'relatedJob',
        field: 'relatedJob',
        width: 150,
        valueFormatter: (params) => {
          return params.value
        }
      }, {
        headerName: this.$t('SeaExport.CustomerLevel'),
        colId: 'customerTypeId',
        field: 'customerTypeId',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', Number(params.value), 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContractStatus'),
        colId: 'contractStatus',
        field: 'contractStatus',
        width: 150
      }, {
        headerName: this.$t('SeaExport.SalesOfGoods'),
        colId: 'cargoSalesId',
        field: 'cargoSalesId',
        hide: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ConsignationCompany'),
        colId: 'customerId',
        field: 'customerId',
        valueFormatter: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.PortOfLoading'),
        colId: 'loadingPortCode',
        field: 'loadingPortCode',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.TransitPort'),
        colId: 'transferPortCode',
        field: 'transferPortCode',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.PortOfDischarge'),
        colId: 'dischargingPortCode',
        field: 'dischargingPortCode',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.ExtraChargeClause'),
        field: 'surchargeItemInfo',
        width: 180,
        colId: 'surchargeItemInfo'
      }, {
        headerName: this.$t('SeaExport.ConsignationStatus'),
        colId: 'crossTenantHistoryState',
        field: 'crossTenantHistoryState',
        valueGetter: (params) => {
          if (params.data) {
            // 交叉委托：委托方关联业务的预审状态，为已审核时，显示“已委托”
            if (params.data.relatedJobLob === 'SE') {
              if (params.data.relatedPreverifyState === SystemConstants.VERIFYING_AUDITED.code || params.data.relatedPreverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code) {
                return this.$t('SeaExport.Commissioned')
              }
            }
            return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.data.crossTenantHistoryState)
          }
          return ''
        },
        width: 150,
        /* 设置列筛选功能的过滤器 */
        filter: false,
        filterParams: {}
      }, {
        headerName: this.$t('SeaExport.ConsignationStatusTime'),
        colId: 'crossTenantHistoryStateDate',
        field: 'crossTenantHistoryStateDate',
        width: 150
      }, {
        headerName: this.$t('SeaExport.PlaceOfDelivery'),
        colId: 'destinationPortCode',
        field: 'destinationPortCode',
        hide: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.AirlineArea'),
        field: 'regionName',
        colId: 'regionName',
        hide: true,
        cellRenderer: (params) => {
          if (params.value && !this.isZh) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'name', params.value, 'nameEnglish')
          }
          return params.value
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ServiceCode'),
        field: 'vesselLineCode',
        colId: 'vesselLineCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
        field: 'scNo',
        colId: 'scNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.DateOfDeparture2'),
        field: 'etd',
        colId: 'etd',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfArrival2'),
        field: 'eta',
        colId: 'eta',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfCreation'),
        field: 'dateCreated',
        colId: 'dateCreated',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.RealDepartureTime'),
        field: 'actualUnBerthPlanDate',
        colId: 'actualUnBerthPlanDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CustomerSelfRelease'),
        field: 'customerSelfRelease',
        colId: 'customerSelfRelease',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.getCustomerSelfReleaseFunction(Number(params.data.customerSelfRelease))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CYCutOffDate2'),
        field: 'customCutoff',
        colId: 'customCutoff',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.TaxNature'),
        field: 'taxNature',
        colId: 'taxNature',
        cellRenderer: params => {
          return ColumnUtils.taxNatureLabelFunction(params.value)
        },
        width: 120
      },
      {
        headerName: this.$t('SeaExport.PlannedBerthingTime'),
        field: 'berthPlanDateStr',
        colId: 'berthPlanDateStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.ActualBerthingTime'),
        field: 'actualBerthPlanDateStr',
        colId: 'actualBerthPlanDateStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.EquipmentEstimatedReturnTimeFrom'),
        field: 'returnPeriodBeginStr',
        colId: 'returnPeriodBeginStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.EquipmentEstimatedReturnTimeTo'),
        field: 'returnPeriodEndStr',
        colId: 'returnPeriodEndStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.CustomerCyCutOffDate'),
        field: 'customerCutoffStr',
        colId: 'customerCutoffStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.CustomerShutOutDate'),
        field: 'customerShutoutStr',
        colId: 'customerShutoutStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.CargoReadyDate'),
        field: 'estimatedPackDateStr',
        colId: 'estimatedPackDateStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.ArrivalTime2'),
        field: 'arrivalTimeStr',
        colId: 'arrivalTimeStr',
        width: 150,
        hide: true
      },
      {
        headerName: this.$t('SeaExport.DocCutOffDate'),
        field: 'fileCutoff',
        colId: 'fileCutoff',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DeclareCutOffDate'),
        field: 'declareCutOff',
        colId: 'declareCutOff',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.SequenceNumber'),
        field: 'jobNo5',
        colId: 'jobNo5',
        width: 150
      }, {
        headerName: this.$t('SeaExport.BookingAgent'),
        field: 'bookingAgent',
        colId: 'bookingAgent',
        hide: true,
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
        },
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.CarrierAgent'),
        field: 'carrierAgentId',
        colId: 'carrierAgentId',
        hide: true,
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName') : ''
        },
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.ShippingCompany'),
        field: 'carrierId',
        colId: 'carrierId',
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.HaulageCompany'),
        field: 'carryingCmp',
        colId: 'carryingCmp',
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.Vessel'),
        field: 'vessel',
        colId: 'vessel',
        width: 150
      }, {
        headerName: this.$t('SeaExport.Voyage'),
        field: 'voyageFlight',
        colId: 'voyageFlight',
        width: 150
      }, {
        headerName: this.$t('SeaExport.BookingNo'),
        field: 'bookingNo',
        colId: 'bookingNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.MasterBillNo'),
        field: 'mbl',
        colId: 'mbl',
        width: 150
      }, {
        headerName: this.$t('SeaExport.BusinessReferenceNo'),
        field: 'customerRefNo',
        colId: 'customerRefNo',
        width: 150
      }, {
        headerName: this.$t('queryJob.destinationAgent'),
        field: 'destinationAgent',
        colId: 'destinationAgent',
        hide: true,
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
        },
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.NominatedAgent'),
        field: 'designationAgent',
        colId: 'designationAgent',
        hide: true,
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
        },
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.ContainerNo'),
        field: 'containerNos',
        colId: 'containerNos',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Warehouse'),
        field: 'warehouseCmp',
        colId: 'warehouseCmp',
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
        field: 'quantityContract',
        colId: 'quantityContract',
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CommissionedGrossWeight'),
        field: 'weightContract',
        colId: 'weightContract',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CommissionedVolume'),
        field: 'cubageContract',
        colId: 'cubageContract',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualQuantity'),
        field: 'quantityActual',
        colId: 'quantityActual',
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualWeight'),
        field: 'weightActual',
        colId: 'weightActual',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualVolume'),
        field: 'cubageActual',
        colId: 'cubageActual',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ChargedWeight'),
        field: 'chargeWeight',
        colId: 'chargeWeight',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.FLCLType'),
        field: 'containerLoadType',
        colId: 'containerLoadType',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          }
          return
        },
        hide: true,
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
        }
      }, {
        headerName: this.$t('SeaExport.SolicitationType'),
        field: 'cargoSource',
        colId: 'cargoSource',
        cellRenderer: (params) => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.LocalService'),
        field: 'loadingTerm',
        colId: 'loadingTerm',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
          }
          return
        },
        filterValueGetter: (params) => {
          return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
        },
        filterParams: {},
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContractRateProperty'),
        field: 'bookingTerm',
        colId: 'bookingTerm',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.bookingTermLabelFunction(params.data, params.data.bookingTerm)
          }
          return
        },
        filterValueGetter: (params) => {
          return ColumnUtils.bookingTermLabelFunction(params.data, params.data.bookingTerm)
        },
        filterParams: {},
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.IssueMethod'),
        field: 'mblOnly',
        colId: 'mblOnly',
        cellRenderer: (params) => {
          return ColumnUtils.mblOnlyLabelFunction(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.WarehouseNo'),
        field: 'warehouseNo',
        colId: 'warehouseNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ItemNo'),
        field: 'poNo',
        colId: 'poNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SoNo'),
        field: 'soNo',
        colId: 'soNo',
        hide: true,
        width: 150,
        tooltipValueGetter: (params) => params.value
      }, {
        headerName: this.$t('SeaExport.TradeMethod'),
        field: 'tradeTerm',
        colId: 'tradeTerm',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.TradeTerms2'),
        field: 'incoTerm',
        colId: 'incoTerm',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MasterBLFreightTerm'),
        field: 'paymentTermMBL',
        colId: 'paymentTermMBL',
        cellRenderer: (params) => {
          return ColumnUtils.paymentTermLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.HBLFreightClause'),
        field: 'paymentTermHBL',
        colId: 'paymentTermHBL',
        cellRenderer: (params) => {
          return ColumnUtils.paymentTermLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLTransportationClause'),
        field: 'freightTerm',
        colId: 'freightTerm',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLTransportationClause'),
        field: 'freightTermHBL',
        colId: 'freightTermHBL',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContainerDescription'),
        field: 'containerDesc',
        colId: 'containerDesc',
        cellRenderer: (params) => {
          return ColumnUtils.containerDescLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CaseNoSealNo'),
        colId: 'tmpContainerNo',
        field: 'tmpContainerNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLSplitNo'),
        field: 'mBLSplitNo',
        colId: 'mBLSplitNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLSplitNo'),
        field: 'hBLSplitNo',
        colId: 'hBLSplitNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.HarborDistrict'),
        field: 'portDistrict',
        colId: 'portDistrict',
        width: 150
      }, {
        headerName: this.$t('SeaExport.SOPStatus'),
        field: 'sopState',
        colId: 'sopState',
        width: 100,
        tooltipValueGetter: (params) => params.value
      }, {
        headerName: 'HDS',
        colId: 'hds',
        field: 'hds',
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        width: 150
      }, {
        headerName: 'TEU',
        colId: 'teu',
        field: 'teu',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Operation'),
        field: 'op',
        colId: 'op',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.Sales'),
        field: 'sales',
        colId: 'sales',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
        },
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.Accrued'),
        field: 'provisioned',
        colId: 'provisioned',
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerService'),
        field: 'csr',
        colId: 'csr',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Documents'),
        field: 'dc',
        colId: 'dc',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.AirlinePerson'),
        field: 'planner',
        colId: 'planner',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.BusinessCreator'),
        field: 'createdBy',
        colId: 'createdBy',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.CYOpeningTime'),
        field: 'terminalOpendate',
        colId: 'terminalOpendate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PortAreaCYCutOffTime'),
        field: 'terminalCutoff',
        colId: 'terminalCutoff',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'),
        field: 'loadingDate',
        colId: 'loadingDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.CargoActArrivalDatePacking'),
        field: 'actLoadingDate',
        colId: 'actLoadingDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.ShutOut'),
        field: 'shutOut',
        colId: 'shutOut',
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.Status'),
        field: 'jobState',
        colId: 'jobState',
        valueGetter: (params) => {
          return ColumnUtils.getJobStateForBlock(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.getJobStateForBlock(params.data)
        },
        width: 150
      }, {
        headerName: 'HBL NO',
        field: 'hblNo',
        colId: 'hblNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.PortCodeOfDischarge'),
        field: 'portCode',
        colId: 'portCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.AirlineCode'),
        field: 'laneCode',
        colId: 'laneCode',
        width: 150
      }, {
        headerName: this.$t('SeaExport.DangerousGoodsClassification'),
        field: 'danClassNo',
        colId: 'danClassNo',
        hide: true,
        width: 200
      }, {
        headerName: this.$t('SeaExport.DangerousGoodsUNNo'),
        field: 'danUNNo',
        colId: 'danUNNo',
        hide: true,
        width: 200
      }, {
        headerName: this.$t('SeaExport.CustomsBroker'),
        field: 'customsBroker',
        colId: 'customsBroker',
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_9') : ''
        },
        hide: true,
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.FinalDestination'),
        hide: true,
        field: 'destinationPlace',
        colId: 'destinationPlace',
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLConsignee'),
        field: 'hBLConsignee',
        colId: 'hBLConsignee',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLShipper'),
        field: 'shipperCode',
        colId: 'shipperCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CargoType'),
        field: 'cargoType',
        colId: 'cargoType',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomJobType'),
        field: 'customJobType',
        colId: 'customJobType',
        valueGetter: (params) => {
          return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.SE.code, this.isFba)
        },
        hide: true,
        width: 150,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.OperationTips'),
        field: 'operationTips',
        colId: 'operationTips',
        hide: true,
        width: 150
      }, {
        headerName: UICustomUtil.handleUICustomColumnDefsField(UICustomConstants.SEA_BOOKING_MODULE, this.curOfficeId, 'remarks', this.$t('SeaExport.Remarks')),
        field: 'remarks',
        colId: 'remarks',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField1'),
        field: 'userDefinedField1',
        colId: 'userDefinedField1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField2'),
        field: 'userDefinedField2',
        colId: 'userDefinedField2',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField3'),
        field: 'userDefinedField3',
        colId: 'userDefinedField3',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
        field: 'cargoChineseName',
        colId: 'cargoChineseName',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
        field: 'cargoEnglishName',
        colId: 'cargoEnglishName',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLBlType'),
        field: 'mblReleaseType',
        colId: 'mblReleaseType',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.MBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(params.data.mblReleaseType))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: 'MBL' + this.$t('SeaExport.BlProperty'),
        field: 'typeMBL',
        colId: 'typeMBL',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.typeMBLLabelFunc(Number(params.data.typeMBL))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: 'HBL' + this.$t('SeaExport.BlProperty'),
        field: 'typeHBL',
        colId: 'typeHBL',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.typeHBLLabelFunc(Number(params.data.typeHBL))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: 'HBL' + this.$t('SeaExport.SerialNo'),
        field: 'serialNo',
        colId: 'serialNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLCheckingStatus'),
        field: 'mblCfmState',
        colId: 'mblCfmState',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.cfmStatusLabelFunc(Number(params.data.mblCfmState))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLReleasingStatus'),
        colId: 'mblReleaseState',
        field: 'mblReleaseState',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.releaseStateLabelFunc(Number(params.data.mblReleaseState))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLBlType'),
        colId: 'hblReleaseType',
        field: 'hblReleaseType',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.HBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(params.data.hblReleaseType))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: 'HBL' + this.$t('SeaExport.BlType2'),
        field: 'hblIssuerBL',
        colId: 'hblIssuerBL',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', params.value, 'name')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLCheckingStatus'),
        colId: 'hblCfmState',
        field: 'hblCfmState',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.cfmStatusLabelFunc(Number(params.data.hblCfmState))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLReleasingStatus'),
        colId: 'hblReleaseState',
        field: 'hblReleaseState',
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.releaseStateLabelFunc(Number(params.data.hblReleaseState))
          }
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Consignee'),
        colId: 'consigneeLine1',
        field: 'consigneeLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Shipper'),
        field: 'shipperLine1',
        colId: 'shipperLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.NotifyParty'),
        field: 'notifyLine1',
        colId: 'notifyLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MblShipperLine1'),
        field: 'mblShipperLine1',
        colId: 'mblShipperLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MblConsigneeLine1'),
        field: 'mblConsigneeLine1',
        colId: 'mblConsigneeLine1',
        hide: true,
        width: 150,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.MblNotifyLine1'),
        field: 'mblNotifyLine1',
        colId: 'mblNotifyLine1',
        hide: true,
        width: 150,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('SeaExport.DocDispatchingPlace'),
        field: 'docDispatchingPlace',
        colId: 'docDispatchingPlace',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.DocDispatchingPlace'),
        field: 'docDispatchingPlace',
        colId: 'docDispatchingPlace',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.OperationDate'),
        field: 'customsDate',
        colId: 'customsDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DoorAddress'),
        field: 'doorAddr',
        colId: 'doorAddr',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.EstimatedArrivalTime'),
        field: 'estimatedArrivalTime',
        colId: 'estimatedArrivalTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ArrivalTime'),
        field: 'actualArrivalTime',
        colId: 'actualArrivalTime',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualCustomsReleaseTime'),
        field: 'destPortCustomsClearanceTime',
        colId: 'destPortCustomsClearanceTime',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime'),
        field: 'destPortDeliveryTime',
        colId: 'destPortDeliveryTime',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualReturnTime'),
        field: 'destPortReturnTime',
        colId: 'destPortReturnTime',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualDeliveryToWarehouseTime'),
        field: 'deliveryTime',
        colId: 'deliveryTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.UserDefinedField4'),
        field: 'userDefinedField4',
        colId: 'userDefinedField4',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.bargePOL'),
        field: 'bargePOL',
        colId: 'bargePOL',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HsCode'),
        field: 'hsCode',
        colId: 'hsCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectName'),
        field: 'projectName',
        colId: 'projectName',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectBatch'),
        field: 'projectBatch',
        colId: 'projectBatch',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
        field: 'arriveDate',
        colId: 'arriveDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.SecondVessel'),
        field: 'secondVessel',
        colId: 'secondVessel',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SecondVoyage'),
        field: 'secondVoyage',
        colId: 'secondVoyage',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SecondDateOfDeparture'),
        field: 'secondDateOfDeparture',
        colId: 'secondDateOfDeparture',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualDeliveryToCustomersWarehouseTime'),
        field: 'deliveryCompletionDate',
        colId: 'deliveryCompletionDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CyCode'),
        colId: 'yardCode',
        field: 'yardCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerContactPerson'),
        field: 'customerContact',
        colId: 'customerContact',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContactPhone'),
        field: 'telephone',
        colId: 'telephone',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContactMobile'),
        field: 'mobile',
        colId: 'mobile',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualTimeOfArrivalThePort'),
        field: 'realArrivalsDate',
        colId: 'realArrivalsDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
        field: 'receivableChargeLockedStatus',
        colId: 'receivableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
        field: 'payableChargeLockedStatus',
        colId: 'payableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('SeaExport.BargeDateOfDeparture'),
        field: 'bargeETD',
        colId: 'bargeETD',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SpecialGoods.SecondarySpecialGoods'),
        field: 'secondarySpecialGoods',
        colId: 'secondarySpecialGoods',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ChannelNo'),
        field: 'channelNo',
        colId: 'channelNo',
        width: 150
      },
      {
        headerName: this.$t('SeaExport.OrderChannels'),
        field: 'salesChannel',
        hide: true,
        width: 180
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
        field: 'receivableChargeInput',
        colId: 'receivableChargeInput',
        width: 150,
        filter: false,
        filterParams: {},
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.chargeInputLabelFunction(params.data.receivableChargeInput)
          }
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
        field: 'costChargeInput',
        colId: 'costChargeInput',
        width: 150,
        filter: false,
        filterParams: {},
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.chargeInputLabelFunction(params.data.costChargeInput)
          }
        }
      },
      {
        headerName: this.$t('SeaExport.FreeDemurrage'),
        field: 'freeDemurrage',
        colId: 'freeDemurrage',
        width: 150,
        filterParams: {}
      }, {
        headerName: this.$t('SeaExport.FreeDetention'),
        field: 'freeDetention',
        colId: 'freeDetention',
        width: 150,
        filterParams: {}
      }, {
        headerName: this.$t('SeaExport.PlanDepartureTime'),
        field: 'unBerthPlanDate',
        colId: 'unBerthPlanDate',
        width: 150,
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.WharfStowage'),
        field: 'wharfStowage',
        colId: 'wharfStowage',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.customsClearance'),
        field: 'customReleaseDate',
        colId: 'customReleaseDate',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.DockRelease'),
        field: 'wharfReleaseDate',
        colId: 'wharfReleaseDate',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CarrierCyCutOffTime'),
        field: 'carrierCyCutOffTime',
        colId: 'carrierCyCutOffTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PortDischargeTime'),
        field: 'portDischargeTime',
        colId: 'portDischargeTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.RailwayDepartureTime'),
        field: 'railwayDepartureTime',
        colId: 'railwayDepartureTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.RailwayDischargeTime'),
        field: 'railwayDischargeTime',
        colId: 'railwayDischargeTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.EstimatedCustomsReleaseTime'),
        field: 'estimatedCustomsReleaseTime',
        colId: 'estimatedCustomsReleaseTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.EstimatedPickupTime'),
        field: 'estimatedPickUpTime',
        colId: 'estimatedPickUpTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualPickUpTime'),
        field: 'actualPickUpTime',
        colId: 'actualPickUpTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.EstimatedDeliveryToWarehouseTime'),
        field: 'estimatedDeliveryToWarehouseTime',
        colId: 'estimatedDeliveryToWarehouseTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.EstimatedReturnTime'),
        field: 'estimatedReturnTime',
        colId: 'estimatedReturnTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.BackUpWarehouse'),
        field: 'backUpWarehouseCmp',
        colId: 'backUpWarehouseCmp',
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.quotationNum'),
        colId: 'quotationNo',
        field: 'quotationNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
        field: 'salesDept',
        colId: 'salesDept',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
        field: 'opDepartment',
        colId: 'opDepartment',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.CategoryOfGoods'),
        field: 'cargoCode',
        colId: 'cargoCode',
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
        },
        hide: true,
        width: 200
      }, {
        headerName: this.$t('SeaExport.ManifestImportUser'),
        field: 'manifestUser',
        colId: 'manifestUser',
        hide: true,
        width: 100,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.manifestUser), 'chineseName')
          }
        }
      }, {
        headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
        field: 'atd',
        colId: 'atd',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualDateOfArrival2'),
        field: 'ata',
        colId: 'ata',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
        field: 'userDefinedRoleId1',
        colId: 'userDefinedRoleId1',
        width: 150,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
        field: 'userDefinedRoleId2',
        colId: 'userDefinedRoleId2',
        width: 150,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
        field: 'userDefinedRoleId3',
        colId: 'userDefinedRoleId3',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
        field: 'userDefinedRoleId4',
        colId: 'userDefinedRoleId4',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
        field: 'userDefinedRoleId5',
        colId: 'userDefinedRoleId5',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
        field: 'userDefinedRoleId6',
        colId: 'userDefinedRoleId6',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
        field: 'userDefinedRoleId7',
        colId: 'userDefinedRoleId7',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.PreCommitUser'),
        field: 'preCommitUser',
        colId: 'preCommitUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.PreCommitDate'),
        field: 'preCommitDate',
        colId: 'preCommitDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.CommitUser'),
        field: 'commitUser',
        colId: 'commitUser',
        valueGetter: (params) => {
          if (params.data) {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.commitUser), 'auto_op')
          }
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.SubmissionDate'),
        field: 'submissionDate',
        colId: 'submissionDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.FcAuditUser'),
        field: 'fcAuditUser',
        colId: 'fcAuditUser',
        valueGetter: (params) => {
          if (params.data) {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.fcAuditUser), 'auto_op')
          }
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.FcAuditDate'),
        field: 'fcAuditDate',
        colId: 'fcAuditDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.LockJobUser'),
        field: 'lockJobUser',
        colId: 'lockJobUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.LockJobDate'),
        field: 'lockJobDate',
        colId: 'lockJobDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.InnerContractNo'),
        field: 'contractNo',
        colId: 'contractNo',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('CargoMsg.Cargo_SpecialPriceInstructions'),
        field: 'salePriceRemarks',
        colId: 'salePriceRemarks',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.HBLRemarks'),
        field: 'hblRemarks',
        colId: 'hblRemarks',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.BillExchangeAgent'),
        field: 'exChangeAgent',
        colId: 'exChangeAgent',
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        },
        width: 200,
        suppressColumnsToolPanel: this.isSalesForSzfs
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
        field: 'salesOffice',
        colId: 'salesOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
        field: 'opOffice',
        colId: 'opOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
        field: 'trustJobState',
        colId: 'trustJobState',
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.getJobStateCN(Number(params.value))
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
        field: 'relatedJobState',
        colId: 'relatedJobState',
        hide: true,
        valueGetter: params => {
          if (params.data) {
            return ColumnUtils.getJobStateCN(Number(params.data.relatedJobState))
          }
        },
        width: 150
      }, {
        headerName: this.$t('queryJob.receivablesWriteOfStatus'),
        colId: 'verifyStateReceivable',
        field: 'verifyStateReceivable',
        width: 150,
        hide: true
      }, {
        headerName: this.$t('queryJob.payablesWriteOfStatus'),
        colId: 'verifyStatePayable',
        field: 'verifyStatePayable',
        width: 150,
        hide: true
      }, {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        width: 150,
        hide: true,
        valueGetter: params => {
          if (params.data) {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.data.receivableInvoiceState)
          }
        }
      }, {
        headerName: this.$t('SeaExport.CustomerClosingTime'),
        field: 'customerFileCutoff',
        colId: 'customerFileCutoff',
        width: 150,
        hide: true,
        valueGetter: params => {
          if (params.data) {
            return ColumnUtils.dateMinutesLabelFunc(params.data.customerFileCutoff)
          }
        }
      }, {
        headerName: this.$t('SeaExport.MBLIssueBillLading'),
        colId: 'mblBliStatus',
        field: 'mblBliStatus',
        width: 150,
        hide: true,
        valueGetter: params => {
          if (params.data) {
            return ColumnUtils.constantsBillLadingIssuingStatus(Number(params.data.mblBliStatus))
          }
        }
      },
      {
        headerName: this.$t('SeaExport.HBLIssueBillLading'),
        colId: 'hblBliStatus',
        field: 'hblBliStatus',
        width: 150,
        hide: true,
        valueGetter: params => {
          if (params.data) {
            return ColumnUtils.constantsBillLadingIssuingStatus(Number(params.data.hblBliStatus))
          }
        }
      },
      {
        headerName: this.$t('SeaExport.RelatedCommitUser'),
        field: 'relatedCommitUser',
        colId: 'relatedCommitUser',
        hide: true,
        cellRenderer: params => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.RelatedSubmissionDate'),
        field: 'relatedSubmissionDate',
        colId: 'relatedSubmissionDate',
        hide: true,
        cellRenderer: params => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.BookingDate'),
        field: 'bookingDate',
        colId: 'bookingDate',
        width: 150,
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.RelatedPreCommitUser'),
        field: 'relatedPreCommitUser',
        colId: 'relatedPreCommitUser',
        hide: true,
        cellRenderer: params => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.RelatedPreCommitDate'),
        field: 'relatedPreCommitDate',
        colId: 'relatedPreCommitDate',
        hide: true,
        cellRenderer: params => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      { headerName: this.$t('SeaExport.PreAuditPerson'), field: 'preverifier', width: 180, colId: 'preverifier', hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('SeaExport.PreAuditTime'), field: 'preverifyDate', width: 180, colId: 'preverifyDate', hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      { headerName: this.$t('SeaExport.CargoSize'), field: 'measurements', width: 180, colId: 'measurements', hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
        colId: 'cooperatebranch',
        field: 'cooperatebranch',
        width: 160, minWidth: 160,
        hide: !this.useOrderCenterMode
      }, {
        headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
        colId: 'cooperateBusinessType',
        field: 'cooperateBusinessType',
        width: 200, minWidth: 200,
        hide: !this.useOrderCenterMode
      },
      { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
        field: 'trackingTemplateUuid',
        width: 180,
        colId: 'trackingTemplateUuid',
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
        }
      },
      { headerName: this.$t('SeaExport.CarrierVoyage'), field: 'carrierVoyage', width: 180, colId: 'carrierVoyage', hide: true },
      {
        headerName: this.$t('Message.TerminalCompany'),
        colId: 'terminalCompany',
        field: 'terminalCompany',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_BargeRemarks'),
        field: 'bargeRemarks',
        colId: 'bargeRemarks',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.DispatchVehiclesAtDestinationDoorAddress'),
        colId: 'disDoorAddr',
        field: 'disDoorAddr',
        width: 150
      },
      { headerName: this.$t('SeaExport.BookingEdiSendingChannel'), field: 'bookingSendType', width: 250, colId: 'bookingSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_BookingSendDate'), field: 'bookingSendDate', width: 250, colId: 'bookingSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_BookingReceiptDate'), field: 'bookingReceiptDate', width: 250, colId: 'bookingReceiptDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('Warehouse.WarehouseInState'),
        colId: 'warehouseStatus',
        field: 'warehouseStatus',
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', params.data.warehouseStatus, 'chineseName')
          }
        },
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PlaceOfDeliveryRegion'),
        field: 'placeOfDeliveryRegion',
        width: 100,
        hide: true,
        cellRenderer: (params) => {
          if (params.value && !this.isZh) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'englishName')
          }
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_IncludeSoc'),
        field: 'containerSoc',
        width: 100,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.BL_EDI_SendChannel'),
        field: 'ladingBillSendType',
        width: 250,
        colId: 'ladingBillSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.BL_EDI_SendTime'),
        field: 'ladingBillSendDate',
        width: 250,
        colId: 'ladingBillSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CleanManifest_EDI_SendChannel'),
        field: 'ifcsumSendType',
        width: 250,
        colId: 'ifcsumSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.CleanManifest_EDI_SendTime'),
        field: 'ifcsumSendDate',
        width: 250,
        colId: 'ifcsumSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Way99_EDI_SendChannel'),
        field: 'installSendType',
        width: 250,
        colId: 'installSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.Way99_EDI_SendTime'),
        field: 'installSendDate',
        width: 250,
        colId: 'installSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.AMS_EDI_SendTime'), field: 'amsSendDate', width: 250, colId: 'amsSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.AHR_EDI_SendTime'), field: 'afrSendDate', width: 250, colId: 'afrSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PreShippingBill_EDI_SendChannel'),
        field: 'preconfigureShippingSendType',
        width: 250,
        colId: 'preconfigureShippingSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.ShippingBill') + this.$t('SeaExport.SendUser'),
        colId: 'ediSenderId',
        field: 'ediSenderId',
        width: 130,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.PreShippingBill_EDI_SendTime'),
        field: 'preconfigureShippingSendDate',
        width: 250,
        colId: 'preconfigureShippingSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.OverseaAgent_EDI_SendChannel'),
        field: 'overseaAgentSendType',
        width: 250,
        colId: 'overseaAgentSendType',
        valueFormatter: (params) => {
          return ColumnUtils.bookingEdiSendingChannelLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.OverseaAgent_EDI_SendTime'),
        field: 'overseaAgentSendDate',
        width: 250,
        colId: 'overseaAgentSendDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.mblReleasingDate'),
        field: 'mblReleaseDate',
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        hide: true,
        width: 180
      }, {
        headerName: this.$t('SeaExport.Marks'),
        field: 'mark',
        colId: 'mark',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
        field: 'routeCode',
        colId: 'routeCode',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('Message.Customer_Service'),
        colId: 'csrDepartment',
        field: 'csrDepartment',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('Message.Documentation_Department'),
        colId: 'dcDepartment',
        field: 'dcDepartment',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: 'Allocation', field: 'allocation', width: 180, colId: 'allocation', hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_IsCabinSpace'), field: 'availableCabinSpace', width: 180, colId: 'availableCabinSpace', hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DoorRemarks'),
        colId: 'doorRemarks',
        field: 'doorRemarks',
        width: 180,
        hide: true
      }, {
        headerName: this.$t('SeaExport.HBLHBR'),
        colId: 'jointMasterHBLJobNo',
        field: 'jointMasterHBLJobNo',
        width: 180,
        hide: true
      }, {
        headerName: this.$t('SeaExport.MBLHBR'),
        colId: 'jointMasterMBLJobNo',
        field: 'jointMasterMBLJobNo',
        width: 180,
        hide: true
      }, {
        headerName: this.$t('SeaExport.CustomerOffice'),
        field: 'csrOffice',
        colId: 'csrOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.DocumentOffice'),
        field: 'dcOffice',
        colId: 'dcOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.NCReferenceNo'),
        field: 'agentRefNo',
        colId: 'agentRefNo',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.SendProxyForecasts'),
        field: 'sentDestinationPortAgent',
        width: 100,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', !!params.data.sentDestinationPortAgentDate, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.WarehousingInfo'),
        field: 'warehouseInInfo',
        width: 100,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_BookingSendMethod'),
        field: 'bookingSendMethod',
        colId: 'bookingSendMethod',
        width: 50,
        valueFormatter: (params) => {
          return ColumnUtils.bookingSendMethodLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_BookingTransportMode'),
        field: 'bookingTransportMode',
        colId: 'bookingTransportMode',
        width: 50,
        valueFormatter: (params) => {
          return ColumnUtils.bookingTransportModeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_BookingState'),
        field: 'bookingState',
        colId: 'bookingState',
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            if ([JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code].includes(Number(params.data.bookingState))) {
              return ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_FAIL.code)
            }
            return ColumnUtils.jobBookingState(Number(params.data.bookingState))
          }
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_EdiBookingExportState'),
        field: 'ediBookingExportStatus',
        colId: 'ediBookingExportStatus',
        cellRenderer: (params) => {
          return ColumnUtils.bookingExportStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_OriginBookingState'),
        field: 'originBookingState',
        colId: 'originBookingState',
        width: 50
      }, {
        headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
        colId: 'verifyStateReceivableDomestic',
        field: 'verifyStateReceivableDomestic',
        width: 140,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
        colId: 'verifyStateReceivableOversea',
        field: 'verifyStateReceivableOversea',
        width: 140,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_CustomerDemandClearanceNumber'),
        field: 'customsDeclarationCount',
        colId: 'customsDeclarationCount',
        width: 50,
        cellRenderer: (params) => {
          return params.value ? params.value : ''
        }
      },
      { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
        cellRenderer: (params) => {
          return ColumnUtils.booleanLockedStatusLabelFunc(params.value)
        },
        hide: true
      },
      { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true },
      { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true },
      { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      },
      { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
        field: 'companyCreateDate',
        colId: 'companyCreateDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.AdvancePayment'),
        field: 'advancePayment',
        colId: 'advancePayment',
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.CustomsDutyAmount'),
        field: 'customsDutyAmount',
        colId: 'customsDutyAmount',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return this.$numeral(params.value).format('0.00')
        }
      },
      {
        headerName: this.$t('SeaExport.VatAmount'),
        field: 'vatAmount',
        colId: 'vatAmount',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return this.$numeral(params.value).format('0.00')
        }
      },
      {
        headerName: this.$t('SeaExport.PaymentTime'),
        field: 'paymentTime',
        colId: 'paymentTime',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
        colId: 'payableInvoiceState',
        field: 'payableInvoiceState',
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
        hide: true
      }, {
        headerName: this.$t('SeaExport.FormalHblReleaseType'),
        colId: 'formalHblReleaseType',
        field: 'formalHblReleaseType',
        cellRenderer: (params) => {
          if (params.value) {
            return ColumnUtils.formalHblReleaseTypeLabelFunc(Number(params.value))
          }
        },
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.FormalHblStatus'),
        field: 'formalHblState',
        width: 100,
        colId: 'formalHblState',
        cellRenderer: (params) => {
          return ColumnUtils.cfmStatusLabelFunc(Number(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.FormalHblIssuedStatus'),
        colId: 'formalHblBliStatus',
        field: 'formalHblBliStatus',
        width: 150,
        hide: true,
        cellRenderer: params => {
          return ColumnUtils.bliStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('SeaExport.VirtualBillType'),
        field: 'typeVirtualHbl',
        colId: 'typeVirtualHbl',
        cellRenderer: (params) => {
          return ColumnUtils.formalHblTypeLabelFunc(Number(params.value))
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.FormalHblType'),
        field: 'formalHblType',
        colId: 'formalHblType',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', params.value, 'name')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.FormalHblCombineNo'),
        colId: 'jointMasterHAWB2JobNo',
        field: 'jointMasterHAWB2JobNo',
        width: 180,
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
        colId: 'receivableChargeLockedDate',
        field: 'receivableChargeLockedDate',
        width: 200,
        hide: true,
        cellRenderer: (params) => {
          return dateUtils.formatStandardDateTime(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
        colId: 'payableChargeLockedDate',
        field: 'payableChargeLockedDate',
        width: 200,
        hide: true,
        cellRenderer: (params) => {
          return dateUtils.formatStandardDateTime(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.HblEnglishDescriptionOfGoods'),
        field: 'hblCargoEnglishName',
        colId: 'hblCargoEnglishName',
        hide: true,
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return params.data.hblCargoEnglishName.replace(/[\r\n]+/gm, ' ')
        }
      }]
      return result
    },
    finalJobs() {
      if (this.onlyShowSlave) {
        const newJobs = []
        const masterJobKeys = this.jobs.filter(item => item.masterFlag).map(item => item.uuid)
        for (const job of this.jobs) {
          if (job.masterFlag) {
            continue
          }
          if (job.path) {
            const pathItems = job.path.split(',')
            if (masterJobKeys.includes(pathItems[0])) {
              pathItems.splice(0, 1)
              newJobs.push({ ...job, path: pathItems.join(',') })
            } else {
              newJobs.push(job)
            }
          } else {
            newJobs.push(job)
          }
        }
        return newJobs
      }
      return this.jobs
    }
  },
  created() {
    // // 首次进入页面请求接口数据
    // this.refreshPage(true, pageCache.nodePriorityInfoSelected)
    // // 60分钟自动刷新页面
    // this.autoRefresh()
    // this.resetFileTypeCapsMap()
    this.activated()
  },
  mounted() {

  },
  activated() {
    this.activated()
  },
  deactivated() {
    pageCache.nodePriorityInfoSelected = this.nodePriorityInfoSelected
  },
  beforeDestroy() {
    // pageCache.nodePriorityInfoSelected = this.nodePriorityInfoSelected
    this.documentManage.destory()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('virtualHBLWindow', function(e, data) {
      self.virtualHBLWindow(e, data)
    })
    this.documentManage.set('onCellJobNoClick', function(e, uuid) {
      self.onCellJobNoClick(e, uuid)
    })
  },
  methods: {
    // 基于 用户+业务类型 配置
    async loadSopDashboardConfig() {
      try {
        if (this.sopDashboardConfig != null) {
          this.sopNodeNoDataHide = this.sopDashboardConfig[this.lob + '_sopNodeNoDataHide'] || false
          return
        }
        const currentUserInfo = getUserInfo()
        const data = {
          configModule: '11112',
          configName: `local_ui_person_sopDashboard_${currentUserInfo.tenantId}_${currentUserInfo.userId}_11112`,
          configType: 3, // 固定值
          configBy: currentUserInfo.userId,
          tenantId: currentUserInfo.tenantId
        }
        await getPersonQueryConfig(data).then(res => {
          const { data } = res
          if (data && data.length > 0) {
            this.sopDashboardConfig = JSON.parse(data[0].configContent)
            this.sopNodeNoDataHide = this.sopDashboardConfig[this.lob + '_sopNodeNoDataHide'] || false
          } else {
            this.sopDashboardConfig = {}
          }
        })
      } catch (e) {
        // error
      }
    },
    async sopNodeNoDataHideChangeHandle() {
      this.sopDashboardConfig[this.lob + '_sopNodeNoDataHide'] = this.sopNodeNoDataHide
      const currentUserInfo = getUserInfo()
      const data = {
        configModule: '11112',
        configName: `local_ui_person_sopDashboard_${currentUserInfo.tenantId}_${currentUserInfo.userId}_11112`,
        configType: 3, // 固定值
        configContent: JSON.stringify(this.sopDashboardConfig)
      }
      const loading = getLoading4Cxt(this)
      savePersonQueryConfig(data).then(() => {
      })
        .finally(() => {
          loading.close()
        })
      if (this.sopNodeNoDataHide) {
        // 选中节点进行切换
        this.nodePriorityStatistics = this.allNodePriorityStatistics.filter(item => item.countTotal > 0)
        if (!this.nodePriorityStatistics || this.nodePriorityStatistics.length === 0) {
          this.jobs = []
          this.filter.total = 0
          this.filter.pageNum = 1
          if (this.nodePriorityInfoSelected) {
            this.nodePriorityInfoSelected.selected = false
            this.nodePriorityInfoSelected = null
          }
        } else if (this.nodePriorityStatistics.length < this.allNodePriorityStatistics.length) {
          const nodes = this.nodePriorityStatistics.filter(item => item.code === this.nodePriorityInfoSelected.code)
          if (!nodes || nodes.length === 0) {
            // 【取第一个节点】作为【选中节点】
            if (this.nodePriorityInfoSelected) {
              this.nodePriorityInfoSelected.selected = false
              this.jobs = []
              this.filter.total = 0
              this.filter.pageNum = 1
            }
            this.nodePriorityInfoSelected = this.nodePriorityStatistics[0]
            this.nodePriorityInfoSelected.selected = true
            this.filter.code = this.nodePriorityInfoSelected.code
            await this.getPriorityJobsWt()
          }
        }
      } else {
        this.nodePriorityStatistics = this.allNodePriorityStatistics
      }
    },
    async activated() {
      await cache.load(cacheName.CONFIG)
      this.disabledAutoRefresh = false
      this.keepSelectedNode = false
      this.keepQueryCondition = false
      this.resetQueryOnTemplateSwitch = false
      const sopWorkTaskBoardSetting = LocalStorageUtilsNew.getConfiguration('sopWorkTaskBoard-setting')
      if (sopWorkTaskBoardSetting) {
        this.disabledAutoRefresh = sopWorkTaskBoardSetting.disabledAutoRefresh
        this.keepSelectedNode = sopWorkTaskBoardSetting.keepSelectedNode
        this.keepQueryCondition = sopWorkTaskBoardSetting.keepQueryCondition
        this.resetQueryOnTemplateSwitch = sopWorkTaskBoardSetting.resetQueryOnTemplateSwitch
      }
      this.defaultLevels = ''
      const dataPriorityDisplaySetting = LocalStorageUtilsNew.getConfiguration('dataPriorityDisplay-setting')
      if (dataPriorityDisplaySetting) {
        this.defaultLevels = dataPriorityDisplaySetting.defaultDisplay
      }
      if (this.isFirst) {
        this.refreshPage(true, pageCache.nodePriorityInfoSelected)
        this.isFirst = false
      } else {
        if (!this.keepQueryCondition) {
          if (this.$refs[this.filterDialogRefName]) {
            this.$refs[this.filterDialogRefName].clear()
            if (this.keepSelectedNode) {
              this.$refs[this.filterDialogRefName].initTemplateKey(this.filter.trackingTemplateUuid)
            } else {
              const defaultTemplateKey = this.defaultTemplateMap.get(this.lob) ? this.defaultTemplateMap.get(this.lob)['uuid'] : null
              this.$refs[this.filterDialogRefName].initTemplateKey(defaultTemplateKey)
            }
          }
        }
        if (!this.disabledAutoRefresh) {
          if (this.$refs[this.filterDialogRefName]) {
            this.$refs[this.filterDialogRefName].handleFilter()
          }
        }
      }
      if (!this.disabledAutoRefresh) {
      // 60分钟自动刷新页面
        this.autoRefresh()
      }
      this.resetFileTypeCapsMap()
    },
    refreshBySetting() {
      if (!this.disabledAutoRefresh) {
        this.refreshPage()
      }
    },
    async resetFileTypeCapsMap() {
      this.fileTypeCapsMap.clear()
      await DocumentCategory.getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.lob }).then(res => {
        res.data.forEach(item => {
          if (item.type === 2) {
            this.fileTypeCapsMap.set(StrUtils.toUpperCase(item.code), item.chineseName)
          }
        })
      })
    },
    async refreshPage(showLoading = true, selectedNodePriorityInfo) {
      try {
        // this.refreshTime = formatHourMinute(new Date())
        this.$emit('refreshTime', formatHourMinute(new Date()))
        let loading = null
        if (showLoading) {
          loading = getLoading('sop-work-task-board')
        }
        // 获取用户的【工作任务】【业务类型】列表
        await getLobsWt().then(async res => {
          if (res.data && res.data.length > 0) {
            this.businessTypes = BUSINESS_TYPES.filter(item => res.data.findIndex(lob => lob === item.name) > -1)
            // 获取用户的【工作任务】【模板】列表
            if (this.businessTypes && this.businessTypes.length > 0) {
              await getTemplatesWt({ lobs: res.data.join(',') }).then(async res => {
                this.templatesMap = new Map(Object.entries(res.data))
                for (const [key, value] of this.templatesMap) {
                  const defaultTemplates = value.filter(p => p.homepageDisplayOnUserWt)
                  const template = defaultTemplates && defaultTemplates.length > 0 ? defaultTemplates[0] : null
                  this.defaultTemplateMap.set(key, template)
                  this.selectedTemplateMap.set(key, template)
                  if (key === this.lob) {
                    this.$refs[this.filterDialogRefName].initTemplateKey(template ? template['uuid'] : null)
                  }
                }
                // console.log('this.lob:', this.lob)
                // console.log('this.sopWorkTaskBoardLob:', this.sopWorkTaskBoardLob)
                if (this.lob) {
                  if (this.businessTypes && this.businessTypes.length > 0) {
                    const businessTypes = this.businessTypes.filter(item => item.name === this.lob)
                    if (!businessTypes || businessTypes.length === 0) {
                      // 配置中的业务 不在 可见列表中，则随机取一个
                      this.lob = this.businessTypes[0].name
                    }
                  } else {
                    this.lob = null
                  }
                } else {
                  this.lob = this.businessTypes[0].name
                }
                this.templates = this.templatesMap.get(this.lob)
                await this.lobChange(showLoading, selectedNodePriorityInfo)
              })
            }
            // await this.lobChange()
          }
        }).finally(() => {
          if (showLoading) {
            loading.close()
          }
        })
      } catch (e) {
        // error
      }
    },
    onRowClassName({ row }) {
      if (row.selected) {
        return 'template-row template-selected'
      }
      return 'template-row'
    },
    async onTemplateClick(row) {
      this.templates = Array.from(this.templates, p => {
        p.selected = p.uuid === row.uuid
        return p
      })
      this.selectedTemplateMap.set(this.lob, row)
      this.$refs[this.filterDialogRefName].initTemplateKey(row['uuid'])
      this.filter.total = 0
      this.filter.pageNum = 1
      // this.filter.pageSize = 15
      this.filter.trackingTemplateUuid = row.uuid
      await this.loadData()
    },
    async loadData(showLoading = true) {
      let loading = null
      try {
        // this.loading = getLoading('sop-work-task-board')
        if (showLoading) {
          loading = getLoading('sop-work-task-board')
        }
        // const loading = getLoading('sop-work-task-board')
        let nodeTotalMap = null
        if (this.resetQueryOnTemplateSwitch) {
          const filter = {
            total: 0,
            pageNum: 1,
            pageSize: this.filter.pageSize,
            businessStartTime: dateUtils.formatStandardDate(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 90)),
            businessEndTime: null,
            showPriorityHigh: true
          }
          filter.lob = this.filter.lob
          filter.branchId = this.filter.branchId
          filter.trackingTemplateUuid = this.filter.trackingTemplateUuid
          await getNodePriorityJobCountWt(filter).then(res => {
            this.filterByDefaultLevels(res.data)
            nodeTotalMap = new Map()
            for (const item of res.data) {
              nodeTotalMap.set(item.code, item)
            }
          })
        }
        await getNodePriorityJobCountWt(this.filter).then(async res => {
          this.filterByDefaultLevels(res.data)
          // 保证配置一定加载完毕
          await this.loadSopDashboardConfig()
          this.allNodePriorityStatistics = res.data
          if (this.sopNodeNoDataHide) {
            this.nodePriorityStatistics = this.allNodePriorityStatistics.filter(item => item.countTotal > 0)
          } else {
            this.nodePriorityStatistics = this.allNodePriorityStatistics
          }
          if (nodeTotalMap) {
            for (const nodePriorityStatistic of this.nodePriorityStatistics) {
              const item = nodeTotalMap.get(nodePriorityStatistic.code)
              if (item) {
                nodePriorityStatistic.countTotal = item.countTotal
                nodePriorityStatistic.enableLow = item.enableLow
                nodePriorityStatistic.countLow = item.countLow
                nodePriorityStatistic.enableMedium = item.enableMedium
                nodePriorityStatistic.countMedium = item.countMedium
                nodePriorityStatistic.enableHigh = item.enableHigh
                nodePriorityStatistic.countHigh = item.countHigh
              }
            }
          }
          this.jobs = []
          if (this.nodePriorityStatistics && this.nodePriorityStatistics.length > 0) {
            // 优选取【上次的选中节点】作为【选中节点】
            if (this.nodePriorityInfoSelected) {
              const nodes = this.nodePriorityStatistics.filter(item => item.code === this.nodePriorityInfoSelected.code)
              if (nodes && nodes.length > 0) {
                this.nodePriorityInfoSelected = nodes[0]
                this.nodePriorityInfoSelected.selected = true
              } else {
                // 其次【取第一个节点】作为【选中节点】
                this.nodePriorityInfoSelected = this.nodePriorityStatistics[0]
                this.nodePriorityInfoSelected.selected = true
              }
            } else {
              // 其次【取第一个节点】作为【选中节点】
              this.nodePriorityInfoSelected = this.nodePriorityStatistics[0]
              this.nodePriorityInfoSelected.selected = true
            }
            this.filter.code = this.nodePriorityInfoSelected.code
            await this.getPriorityJobsWt()
          }
        })
      } catch (e) {
        // error
      } finally {
        if (showLoading && loading) {
          loading.close()
        }
      }
    },
    // 根据默认显示的优先级进行过滤
    filterByDefaultLevels(data) {
      if (!this.defaultLevels) {
        return
      }
      const levels = this.toNumArray(this.defaultLevels)
      for (const row of data) {
        let countLow = 0
        let countMedium = 0
        let countHigh = 0
        let enableLow = false
        let enableMedium = false
        let enableHigh = false
        for (const level of levels) {
          switch (level) {
            case PRIORITY_LOW.code:
              countLow = Number(row.countLow) || 0
              enableLow = row.enableLow
              break
            case PRIORITY_MEDIUM.code:
              countMedium = Number(row.countMedium) || 0
              enableMedium = row.enableMedium
              break
            case PRIORITY_HIGH.code:
              countHigh = Number(row.countHigh) || 0
              enableHigh = row.enableHigh
              break
          }
        }
        row.countLow = String(countLow)
        row.enableLow = enableLow
        row.countMedium = String(countMedium)
        row.enableMedium = enableMedium
        row.countHigh = String(countHigh)
        row.enableHigh = enableHigh
        row.countTotal = String(countLow + countMedium + countHigh)
      }
    },
    async getPriorityJobsWt(showLoading = true) {
      let loading = null
      try {
        if (showLoading) {
          loading = getLoading('sop-work-task-board')
        }
        // const loading = getLoading('sop-work-task-board')
        let priorityjobTotal = null
        if (this.resetQueryOnTemplateSwitch) {
          const filter = {
            total: 0,
            pageNum: 1,
            pageSize: this.filter.pageSize,
            businessStartTime: dateUtils.formatStandardDate(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 90)),
            businessEndTime: null,
            showPriorityHigh: true
          }
          filter.lob = this.filter.lob
          filter.branchId = this.filter.branchId
          filter.trackingTemplateUuid = this.filter.trackingTemplateUuid
          filter.code = this.filter.code
          filter.queryJobTotal = true
          filter.level = this.defaultLevels
          await getPriorityJobsWt(filter).then(res => {
            this.filterByDefaultLevels([res.data.sopNodeJobStatisticVo])
            priorityjobTotal = res.data
          })
        }
        const params = { ...this.filter }
        params.level = params.level || this.defaultLevels
        await getPriorityJobsWt(params).then(res => {
          this.filterByDefaultLevels([res.data.sopNodeJobStatisticVo])
          this.jobs = res.data.jobPageInfo.list
          this.filter.total = res.data.jobPageInfo.total ? Number(res.data.jobPageInfo.total) : 0
          if (priorityjobTotal) {
            this.nodePriorityInfoSelected.countLow = priorityjobTotal.sopNodeJobStatisticVo.countLow
            this.nodePriorityInfoSelected.countMedium = priorityjobTotal.sopNodeJobStatisticVo.countMedium
            this.nodePriorityInfoSelected.countHigh = priorityjobTotal.sopNodeJobStatisticVo.countHigh
            this.nodePriorityInfoSelected.countTotal = priorityjobTotal.sopNodeJobStatisticVo.countTotal
          } else {
            this.nodePriorityInfoSelected.countLow = res.data.sopNodeJobStatisticVo.countLow
            this.nodePriorityInfoSelected.countMedium = res.data.sopNodeJobStatisticVo.countMedium
            this.nodePriorityInfoSelected.countHigh = res.data.sopNodeJobStatisticVo.countHigh
            this.nodePriorityInfoSelected.countTotal = res.data.sopNodeJobStatisticVo.countTotal
          }
          this.tenantInstructions = res.data.tenantInstructions
          // 初始化名称
          if (this.tenantInstructions && this.tenantInstructions.length > 0 && this.jobs && this.jobs.length > 0) {
            const tenantInstructionsObj = {}
            this.tenantInstructions.map((item) => {
              tenantInstructionsObj[item.uuid] = item
            })
            this.jobs.map((item) => {
              if (item.instructionUuids && item.instructionUuids.length > 0) {
                item.instructionBtns = ColumnUtils.instructionNameLabelFunc(tenantInstructionsObj[item.instructionUuids[0]])
              }
            })
          }
        })
      } catch (e) {
        // error
      } finally {
        if (showLoading && loading) {
          loading.close()
        }
      }
    },
    async onCheckInput(row, newVal) {
      const loading = getLoading('sop-work-task-board')
      try {
        let defaultTemplateKey = this.defaultTemplateMap.get(this.lob) ? this.defaultTemplateMap.get(this.lob)['uuid'] : null
        await updateTrackingTemplateUuidsWt({ oldTemplateKey: defaultTemplateKey,
          newTemplateKey: newVal ? row.uuid : null }).finally(() => {
          loading.close()
        })
        const oldDefaultTemplate = this.defaultTemplateMap.get(this.lob)
        if (oldDefaultTemplate) {
          oldDefaultTemplate.homepageDisplayOnUserWt = false
        }
        row.homepageDisplayOnUserWt = newVal
        const template = newVal ? row : null
        this.defaultTemplateMap.set(this.lob, template)
        this.selectedTemplateMap.set(this.lob, template)
        this.$refs[this.filterDialogRefName].initTemplateKey(template ? template['uuid'] : null)
        defaultTemplateKey = this.selectedTemplateMap.get(this.lob) ? this.selectedTemplateMap.get(this.lob)['uuid'] : null
        // this.defaultTemplateName = newVal ? row.templateName : ''
        setTimeout(async() => {
          this.filter.total = 0
          this.filter.pageNum = 1
          // this.filter.pageSize = 15
          this.filter.trackingTemplateUuid = defaultTemplateKey
          await this.loadData()
        })
      } catch {
        // error
      }
      this.popVisible = false
    },
    async lobChange(showLoading = true, selectedNodePriorityInfo) {
      this.templates = this.templatesMap.get(this.lob)
      this.$emit('getActiveNameWt', this.lob)
      const defaultTemplateKey = this.selectedTemplateMap.get(this.lob) ? this.selectedTemplateMap.get(this.lob)['uuid'] : null
      this.filter = {
        total: 0,
        pageNum: 1,
        pageSize: this.filter.pageSize,
        businessStartTime: dateUtils.formatStandardDate(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 90)),
        businessEndTime: null,
        showPriorityHigh: true
      }
      this.filter.lob = this.lob
      this.filter.branchId = this.currentOfficeId
      this.filter.trackingTemplateUuid = defaultTemplateKey
      this.nodePriorityInfoSelected = selectedNodePriorityInfo || null
      if (this.$refs[this.filterDialogRefName]) {
        this.$refs[this.filterDialogRefName].clear()
        this.$refs[this.filterDialogRefName].initTemplateKey(defaultTemplateKey)
      }
      await this.loadUICustomPageInfo()
      await this.loadData(showLoading)
      this.popVisible = false
      this.resetFileTypeCapsMap()
    },
    async loadUICustomPageInfo() {
      if (Number(cache.hqConfig.get('UICustomization')) === 1) {
        if (this.lob === 'SE') {
          const routePath = '/Index/SopWorkTaskBoard/SE'
          const loading = getLoading()
          try {
            await UICustomUtil.loadUICustomPageInfo(routePath, this.$store.getters.currentOfficeId)
          } finally {
            loading.close()
          }
        }
      }
    },
    nodeSelected(nodePriorityInfo, level) {
      level = level ? String(level) : this.defaultLevels
      // const defaultTemplateKey = this.defaultTemplateMap.get(this.lob) ? this.defaultTemplateMap.get(this.lob)['uuid'] : null
      if (this.nodePriorityInfoSelected.code !== nodePriorityInfo.code) {
        nodePriorityInfo.selected = true
        if (this.nodePriorityInfoSelected) {
          this.nodePriorityInfoSelected.selected = false
        }
        this.nodePriorityInfoSelected = nodePriorityInfo
      }
      this.filter.total = 0
      this.filter.pageNum = 1
      // this.filter.pageSize = 15
      this.filter.code = nodePriorityInfo.code
      this.filter.level = level
      this.$refs[this.filterDialogRefName].initLevel(level)
      this.getPriorityJobsWt()
    },
    handleSearch(val, config) {
      this.filterDialog.visible = false
      const defaultTemplateKey = this.selectedTemplateMap.get(this.lob) ? this.selectedTemplateMap.get(this.lob)['uuid'] : null
      // 更多筛选中切换了模板，联动更新右上角的模板选中
      if (val['trackingTemplateUuid'] !== defaultTemplateKey) {
        if (!val['trackingTemplateUuid']) {
          this.selectedTemplateMap.set(this.lob, null)
        } else {
          const templates = this.templates.filter(item => item.uuid === val['trackingTemplateUuid'])
          // console.log('templateName:', JSON.stringify(template))
          const template = templates && templates.length > 0 ? templates[0] : null
          this.selectedTemplateMap.set(this.lob, template)
        }
      }
      delete this.filter.conditions
      Object.assign(this.filter, val)
      if (config && config.length > 0) {
        for (const key of config) {
          if (this.filter.hasOwnProperty(key)) {
            delete this.filter[key]
          }
          if (key === 'businessTime') {
            if (this.filter.hasOwnProperty('businessStartTime')) {
              delete this.filter['businessStartTime']
            }
            if (this.filter.hasOwnProperty('businessEndTime')) {
              delete this.filter['businessEndTime']
            }
          }
        }
      }
      this.$nextTick(async() => {
        this.filter.pageNum = 0
        // this.onQuery(this.filter)
        await this.loadData()
      })
    },
    autoRefresh() {
      if (this.disabledAutoRefresh) {
        if (this.autoTimer) {
          clearInterval(this.autoTimer)
          this.autoTimer = null
        }
        return
      }
      if (!this.autoTimer) {
        this.autoTimer = window.setInterval(() => {
          setTimeout(() => {
            this.refreshPage(false)
          }, 0)
        }, this.time)
        // }, 10000)
      }
    },
    beforeDestroy() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer)
        this.autoTimer = null
      }
    },
    // 节点优先级数量内容封装
    enrichNodeCount(nodePriorityInfo, level) {
      if (PRIORITY_LOW.code === level) {
        if (!nodePriorityInfo.enableLow) {
          return '/'
        }
        if (nodePriorityInfo.countLow > 99) {
          return '99+'
        }
        return nodePriorityInfo.countLow
      } else if (PRIORITY_MEDIUM.code === level) {
        if (!nodePriorityInfo.enableMedium) {
          return '/'
        }
        if (nodePriorityInfo.countMedium > 99) {
          return '99+'
        }
        return nodePriorityInfo.countMedium
      } else if (PRIORITY_HIGH.code === level) {
        if (!nodePriorityInfo.enableHigh) {
          return '/'
        }
        if (nodePriorityInfo.countHigh > 99) {
          return '99+'
        }
        return nodePriorityInfo.countHigh
      }
    },
    // 节点名称内容封装
    enrichNodeName(nodePriorityInfo) {
      if (this.isZh) {
        if (nodePriorityInfo.name.length < 8) {
          return nodePriorityInfo.name + '(' + (nodePriorityInfo.countTotal > 99 ? '99+' : nodePriorityInfo.countTotal) + ')'
        } else {
          return nodePriorityInfo.name.substring(0, 8) + '..</br>' + '(' + (nodePriorityInfo.countTotal > 99 ? '99+' : nodePriorityInfo.countTotal) + ')'
        }
      } else {
        if (nodePriorityInfo.eName.length < 12) {
          return nodePriorityInfo.eName + '(' + (nodePriorityInfo.countTotal > 99 ? '99+' : nodePriorityInfo.countTotal) + ')'
        } else {
          return nodePriorityInfo.eName.substring(0, 12) + '..</br>' + '(' + (nodePriorityInfo.countTotal > 99 ? '99+' : nodePriorityInfo.countTotal) + ')'
        }
      }
    },
    // 节点title内容封装
    enrichNodeTile(nodePriorityInfo) {
      return this.isZh ? nodePriorityInfo.name : nodePriorityInfo.eName
    },
    // 修改SOP状态
    editState() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      let lob = null
      for (const item of rows) {
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
        this.stateDialog.filter = this.filter
        this.stateDialog.rows = rows
        this.stateDialog.visible = true
      })
    },
    // 打开形式分单弹窗
    virtualHBLWindow(jobs, action) {
      // 控制弹窗
      const job = jobs[0]
      if (job) {
        if (!job.virtualHBL) {
          this.$message.warning(this.$t('Message.NoVirtualHBLTip'))
          return
        }
        // 校验权限
        if (!this.$checkPermission(['tab_SEBooking_TabSubBill'])) {
          this.$message.warning(this.$t('Message.NoVirtualHBLAuthTip'))
          return
        }
        // 打开弹窗
        this.jobs.forEach(v => {
          v.uuid = v.jobUuid
        })
        this.virtualHBLDialog.visible = true
        if (action === INSTRUCTION_ACTION_BATCH.code) {
          this.virtualHBLDialog.jobs = jobs
        } else {
          this.virtualHBLDialog.jobs = this.gridApi.rowModel.rowsToDisplay.map(row => row.data)
        }
        this.virtualHBLDialog.job = job
      }
    },
    queryInstructionRecords(data) {
      getInstructionRecordsByJobUuid({ jobUuid: data.jobUuid }).then(res => {
        this.instructionRecordsDialog.rowData = res.data
        this.instructionRecordsDialog.visible = true
      })
    },
    batchInstructionClick(tenantInstruction) {
      let rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const total = rows.length
      // 过滤出符合指令的业务
      rows = rows.filter(p => p.instructionUuids && p.instructionUuids.indexOf(tenantInstruction.uuid) > -1)
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotMatchInstruction'))
        return
      }
      this.instructionClick(tenantInstruction, rows, INSTRUCTION_ACTION_BATCH.code, total)
    },
    instructionClick(tenantInstruction, jobs, action, total) {
      this.currentTenantInstruction = tenantInstruction
      if (!tenantInstruction.platformInstructionCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlatformInstructionDisabled'))
        return
      }
      if (PLATFORM_INSTRUCTION_CODE_VIRTUAL_HBL.code === tenantInstruction.platformInstructionCode) {
        // 形式分单 按钮处理
        this.virtualHBLWindow(jobs, action)
      } else if (PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT.code === tenantInstruction.platformInstructionCode) {
        // 【委托拼箱】发送目的港代理 按钮处理
        // this.bbSendDestinationPortAgent(jobs, action, total)
        this.$refs.oneClickSendWindow.onShowOfSOP(tenantInstruction, jobs, this.nodePriorityInfoSelected.code, action === INSTRUCTION_ACTION_BATCH.code)
      } else if (PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code === tenantInstruction.platformInstructionCode) {
        // 【自拼箱】发送目的港代理 按钮处理
        this.$refs.oneClickSendWindow.onShowOfSOP(tenantInstruction, jobs, this.nodePriorityInfoSelected.code)
      } else if (PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code === tenantInstruction.platformInstructionCode) {
        // 【自拼箱】发送套单代理 按钮处理
        this.$refs.oneClickSendWindow.onShowOfSOP(tenantInstruction, jobs, this.nodePriorityInfoSelected.code)
      } else if (PLATFORM_INSTRUCTION_CODE_UPLOAD_FILE.code === tenantInstruction.platformInstructionCode) {
        // 上传文件 按钮处理
        // this.showCloudFile(jobs)
        this.$refs.uploadFileWindow.onShowOfSOP(tenantInstruction, jobs)
      } else if (PLATFORM_INSTRUCTION_CODE_PRINT_FILE.code === tenantInstruction.platformInstructionCode) {
        // 打印文件 按钮处理
        // this.printFile(jobs, action)
        this.$forceUpdate()
        this.$refs.printFileWindow.onShowOfSOP(tenantInstruction, jobs, action)
      } else if (PLATFORM_INSTRUCTION_CODE_JUMP_PAGE.code === tenantInstruction.platformInstructionCode) {
        // 跳转页面 按钮处理
        this.jumpPage(jobs, action)
      } else if (PLATFORM_INSTRUCTION_CODE_UPDATE_SOP_NODE_STATUS.code === tenantInstruction.platformInstructionCode) {
        // 修改SOP状态 按钮处理
        this.$refs.modifyStateWindow.onShowOfSOP(tenantInstruction, jobs, this.filter)
      } else if (PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code === tenantInstruction.platformInstructionCode) {
        // 自定义表单 按钮处理
        this.$refs.customFormWindow.onShowOfSOP(tenantInstruction, jobs, this.nodePriorityInfoSelected.code, action === INSTRUCTION_ACTION_BATCH.code)
      } else if (PLATFORM_INSTRUCTION_CODE_UPDATE_JOB_STATE.code === tenantInstruction.platformInstructionCode) {
        // 更新业务状态 按钮处理
        this.$refs.updateJobStateWindow.onShowOfSOP(tenantInstruction, jobs)
      }
    },
    instructionCallback(data) {
      data.instructionUuid = this.currentTenantInstruction.uuid
      const loading = getLoading4Cxt(this)
      generateInstructionRecord(data).then(async res => {
        await this.getPriorityJobsWt()
      }).finally(() => {
        loading.close()
      })
    },
    // 【文件上传】指令 回调（不需要生成）
    instructionCallBackByUploadFile() {
      const fileCategoryUuid = this.currentTenantInstruction.instructionRuleJson.fileCategoryUuid
      if (fileCategoryUuid) {
        const jobDocKeysObj = {}
        jobDocKeysObj[this.cloudFile.job.uuid] = fileCategoryUuid
        if (this.cloudFile.jobUuids && this.cloudFile.jobUuids.length > 0) {
          this.cloudFile.jobUuids.forEach(jobUuid => {
            jobDocKeysObj[jobUuid] = fileCategoryUuid
          })
        }
        batchUpdateTrackingForDocumentType(jobDocKeysObj)
      }
      this.getPriorityJobsWt()
    },
    // 【委托拼箱】发送目的港代理
    bbSendDestinationPortAgent(jobs, action, total) {
      const jobsGroupByDestinationAgent = lodash.groupBy(jobs, 'destinationAgent')
      // 【委托拼箱】选择 目的港代理
      if (Object.keys(jobsGroupByDestinationAgent).length > 1) {
        const destinationAgents = []
        Object.keys(jobsGroupByDestinationAgent).forEach(key => {
          destinationAgents.push({
            destinationAgent: key,
            count: jobsGroupByDestinationAgent[key].length
          })
        })
        this.destinationAgentSelectDialog.rowData = destinationAgents
        this.destinationAgentSelectDialog.visible = true
        this.destinationAgentSelectDialog.total = total
        this.destinationAgentSelectDialog.jobCount = jobs.length
        this.destinationAgentSelectDialog.jobsGroupByDestinationAgent = jobsGroupByDestinationAgent
        return
      }
      // 【委托拼箱】发送目的港代理 校验
      this.showCheckingSendDestinationAgentWindow(jobs, action === INSTRUCTION_ACTION_BATCH.code, total)
    },
    // 【委托拼箱】目的港代理 选中处理
    onSelectDestinationAgent(destinationAgent) {
      // 【委托拼箱】发送目的港代理 校验
      this.showCheckingSendDestinationAgentWindow(this.destinationAgentSelectDialog.jobsGroupByDestinationAgent[destinationAgent], false)
    },
    // 【委托拼箱】发送目的港代理 校验
    async showCheckingSendDestinationAgentWindow(jobs, showMatchInstructionTip, total) {
      if (jobs.length > 30) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OperationInstructionBatchTip'))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const res = await checkSendDestinationPortAgentMulti({
          mailTemplateUuid: this.currentTenantInstruction.instructionRuleJson.mailTemplateUuid,
          pushLink: this.currentTenantInstruction.instructionRuleJson.pushLink,
          branchId: this.$store.getters.currentOfficeId,
          lob: jobs[0].lob,
          jobUuids: jobs.map(p => p.uuid),
          trackingCode: this.nodePriorityInfoSelected.code,
          tenantInstructionUuid: this.currentTenantInstruction.uuid
        })
        const { isPass, list, isContinue } = res.data
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        // this.checkingSendDestinationAgentWindow = {}
        this.checkingSendDestinationAgentWindow.isPass = isPass
        this.checkingSendDestinationAgentWindow.masterInfo = ''
        this.checkingSendDestinationAgentWindow.slaveInfo = ''
        this.checkingSendDestinationAgentWindow.rowData = list
        this.checkingSendDestinationAgentWindow.showNext = isContinue
        this.checkingSendDestinationAgentWindow.pushLink = this.currentTenantInstruction.instructionRuleJson.pushLink
        if (showMatchInstructionTip) {
          this.checkingSendDestinationAgentWindow.matchInstructionTip = this.$t('CargoMsg.Cargo_MatchInstructionTip', [total, jobs.length])
        } else {
          this.checkingSendDestinationAgentWindow.matchInstructionTip = ''
        }
        this.checkingSendDestinationAgentWindow.visible = true

        this.sendDestinationPortAgentEmailMultiDialog.jobs = jobs
        this.sendDestinationPortAgentEmailMultiDialog.job = new Job(jobs[0])
        this.sendDestinationPortAgentEmailMultiDialog.destinationAgent = jobs[0].destinationAgent
      } finally {
        loading.close()
      }
    },
    // 【委托拼箱 or 自拼箱】发送目的港代理 校验完成后 下一步
    async sendDestinationPortAgentNext() {
      if (PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT.code === this.currentTenantInstruction.platformInstructionCode) {
        // 【委托拼箱】
        this.bbSendDestinationPortAgentNext()
      } else if (PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code === this.currentTenantInstruction.platformInstructionCode ||
        PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code === this.currentTenantInstruction.platformInstructionCode) {
        // 【自拼箱】
        this.lclSendDestinationPortAgentNext()
      }
    },
    // 【委托拼箱】发送目的港代理 校验完成后 下一步
    async bbSendDestinationPortAgentNext() {
      this.sendDestinationPortAgentEmailMultiDialog.pushLink = this.currentTenantInstruction.instructionRuleJson.pushLink
      this.sendDestinationPortAgentEmailMultiDialog.mailTemplateUuid = this.currentTenantInstruction.instructionRuleJson.mailTemplateUuid
      this.sendDestinationPortAgentEmailMultiDialog.visible = true
    },
    // 【自拼箱】发送目的港代理
    lclSendDestinationPortAgent(jobs) {
      if (jobs.length > 1) {
        this.$message.error(this.$t('CargoMsg.Cargo_LclSendDestinationPortAgentTip'))
        return
      }
      // 【自拼箱】发送目的港代理 校验
      this.lclShowCheckingSendDestinationAgentWindow(jobs[0])
    },
    async lclShowCheckingSendDestinationAgentWindow(job) {
      const loading = getLoading4Cxt(this)
      try {
        const res = await checkSendDestinationPortAgent({
          ifFromInstruction: true,
          mailTemplateUuid: this.currentTenantInstruction.instructionRuleJson.mailTemplateUuid,
          pushLink: this.currentTenantInstruction.instructionRuleJson.pushLink,
          branchId: this.$store.getters.currentOfficeId,
          lob: job.lob,
          jobUuids: [job.uuid],
          trackingCode: this.nodePriorityInfoSelected.code,
          tenantInstructionUuid: this.currentTenantInstruction.uuid,
          exchangeAgent: (PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code === this.currentTenantInstruction.platformInstructionCode && this.exchangeAgentSelectDialog.selectData) ? this.exchangeAgentSelectDialog.selectData.exchangeAgent : 0
        })
        const { isPass, master, slave, list, isContinue } = res.data
        let masterInfo = ''
        if (master.length > 0) {
          const masterFileInfo = Array.from(master, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          masterInfo = this.$t('Message.MasterCheckExist', [masterFileInfo])
        }
        let slaveInfo = ''
        if (slave.length > 0) {
          const slaveFileInfo = Array.from(slave, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          slaveInfo = this.$t('Message.SmallCheckExist', [slaveFileInfo])
        }
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        // this.checkingSendDestinationAgentWindow = {}
        this.checkingSendDestinationAgentWindow.isPass = isPass
        this.checkingSendDestinationAgentWindow.masterInfo = masterInfo
        this.checkingSendDestinationAgentWindow.slaveInfo = slaveInfo
        this.checkingSendDestinationAgentWindow.rowData = list
        this.checkingSendDestinationAgentWindow.showNext = isContinue
        this.checkingSendDestinationAgentWindow.pushLink = this.currentTenantInstruction.instructionRuleJson.pushLink
        this.checkingSendDestinationAgentWindow.matchInstructionTip = ''
        this.checkingSendDestinationAgentWindow.visible = true
        this.lclSendDestinationPortAgentEmailDialog.job = new Job(job)
      } finally {
        loading.close()
      }
    },
    async lclSendDestinationPortAgentNext() {
      this.lclSendDestinationPortAgentEmailDialog.pushLink = this.currentTenantInstruction.instructionRuleJson.pushLink
      if (!this.lclSendDestinationPortAgentEmailDialog.pushLink) {
        if (PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code === this.currentTenantInstruction.platformInstructionCode) {
          this.lclSendDestinationPortAgentEmailDialog.pushLink = SEND_DESTINATIOIN_PORT_AGENT + ''
        } else if (PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code === this.currentTenantInstruction.platformInstructionCode) {
          this.lclSendDestinationPortAgentEmailDialog.pushLink = SEND_PACKAGE_AGENT + ''
        }
      }

      this.lclSendDestinationPortAgentEmailDialog.mailTemplateUuid = this.currentTenantInstruction.instructionRuleJson.mailTemplateUuid
      if (this.lclSendDestinationPortAgentEmailDialog.pushLink === SEND_PACKAGE_AGENT + '') {
        this.lclSendDestinationPortAgentEmailDialog.exchangeAgentData = this.exchangeAgentSelectDialog.selectData
      } else {
        this.lclSendDestinationPortAgentEmailDialog.exchangeAgentData = null
      }
      this.lclSendDestinationPortAgentEmailDialog.visible = true
    },
    // 【自拼箱】发送套单代理
    lclSendPackageAgent(jobs) {
      if (jobs.length > 1) {
        this.$message.error(this.$t('CargoMsg.Cargo_LclSendPackageAgentTip'))
        return
      }
      getExChangeAgentsByJobUuid({ jobUuid: jobs[0].uuid }).then(res => {
        this.exchangeAgentSelectDialog.jobUuid = jobs[0].uuid
        this.exchangeAgentSelectDialog.exchangeAgents = res.data
        this.exchangeAgentSelectDialog.selectData = null
        this.exchangeAgentSelectDialog.visible = true
        this.exchangeAgentSelectDialog.job = jobs[0]
      })
    },
    // 【自拼箱】套单代理 选中处理
    onSelectExchangeAgent(data) {
      this.exchangeAgentSelectDialog.selectData = data
      // 【自拼箱】发送目的港代理 校验
      this.lclShowCheckingSendDestinationAgentWindow(this.exchangeAgentSelectDialog.job)
    },
    // 上传文件 弹窗
    showCloudFile(jobs) {
      this.cloudFile.job = new Job(jobs[0])
      this.cloudFile.lob = jobs[0].lob
      this.cloudFile.jobUuids = jobs.filter(p => p.uuid !== this.cloudFile.job.uuid).map(p => p.uuid)
      this.cloudFile.fileCategory = this.currentTenantInstruction.instructionRuleJson.fileCategory
      this.cloudFile.fileCategoryLabel = this.currentTenantInstruction.instructionRuleJson.fileCategoryLabel
      this.cloudFile.visible = true
    },
    printFile(jobs, action) {
      this.templateSelectorDialog = {
        visible: false,
        data: {}
      }
      this.$forceUpdate()
      this.templateSelectorDialog.lob = jobs[0].lob
      if (INSTRUCTION_ACTION_SINGLE.code === action) {
        const job = jobs[0]
        if (JobUtils.isBlockJob(this.job)) {
          this.$message.warning(this.job.jobNo + this.$t('SeaExport.LockedPleaseContactSupervisorUnlock'))
          return
        }
        // 单个 打印
        if (this.currentTenantInstruction.instructionRuleJson.selectFileType) {
          // 通过 文件类型 获取打印模板
          this.templateSelectorDialog.documentTypeUuid = this.currentTenantInstruction.instructionRuleJson.documentTypeUuid
        } else {
          // 通过 模板uuids 获取打印模板
          //  const params = {
          //   officeId: $store.getters.currentOfficeId,
          //   templateTypes: INSTRUCTION_TEMPLATE_TYPE_MAP.get(job.lob),
          //   templateUuids: this.currentTenantInstruction.instructionRuleJson.templateUuids,
          //   lob: job.lob
          // }
          this.templateSelectorDialog.templateUuids = this.currentTenantInstruction.instructionRuleJson.templateUuids
        }
        let jobData
        if (job.lob === SE.code) {
          jobData = new SeaExportJob(job)
          jobData.loadJobRelated({
            job: true,
            manifestInfos: true,
            seaCargoDoc: true
          })
        } else if (job.lob === SI.code) {
          jobData = new SeaImportJob(job)
          jobData.loadJobRelated({
            job: true,
            seaCargoDoc: true
          })
        } else if (job.lob === AE.code) {
          jobData = new AirExportJob(job)
          jobData.loadJobRelated({
            job: true,
            airCargoDoc: true
          })
        } else if (job.lob === AI.code) {
          jobData = new AirImportJob(job)
          jobData.loadJobRelated({
            job: true,
            airCargoDoc: true
          })
        } else if (job.lob === RE.code || job.lob === RI.code) {
          jobData = new RailwayExportJob(job)
          jobData.loadJobRelated({
            job: true
          })
        } else if (job.lob === IE.code) {
          jobData = new IntegratedJob(job)
          jobData.loadJobRelated({
            job: true
          })
        }
        this.templateSelectorDialog.job = jobData

        if (JobUtils.isBlockJob(this.templateSelectorDialog.job)) {
          this.$message.info(this.templateSelectorDialog.job.jobNo + this.$t('SeaExport.LockedPleaseContactSupervisorUnlock'))
          return
        }

        this.templateSelectorDialog.visible = true
      } else {
        // 批量 打印
        this.templateSelectorDialog.jobUuidList = Array.from(jobs, p => p.uuid)
        if (this.currentTenantInstruction.instructionRuleJson.selectFileType) {
          // 通过 文件类型 获取打印模板
          this.templateSelectorDialog.documentTypeUuid = this.currentTenantInstruction.instructionRuleJson.bachDocumentTypeUuid
        } else {
          // 通过 模板uuids 获取打印模板
          this.templateSelectorDialog.templateUuids = [this.currentTenantInstruction.instructionRuleJson.batchTemplateUuid]
        }

        this.templateSelectorDialog.visible = true
      }
    },
    jumpPage(jobs, action) {
      let pageTab = ''
      let editState = false
      if (this.currentTenantInstruction.instructionParamJson) {
        pageTab = this.currentTenantInstruction.instructionParamJson.PageTab
        editState = this.currentTenantInstruction.instructionParamJson.EditState === 'true'
      }
      const job = jobs[0]
      const jump = JumpUtil.getJumpByPath(this.currentTenantInstruction.instructionRuleJson.jumpPath, job)
      if (jump.roles && !this.$checkPermission(jump.roles)) {
        this.$message.warning(this.$t('Message.NoAccessPermission'))
        return
      }
      const rowData = this.gridApi.rowModel.rowsToDisplay.map(row => row.data)
      const location = { name: jump.routeName, params: { jobNo: job.jobNo, activeTabName: pageTab || jump.tabRouteName,
        jobNos: rowData.map(p => p.jobNo), editState }}
      this.$router.push(lodash.cloneDeep(location))
    },
    onInstructionCallback() {
      this.getPriorityJobsWt()
    },
    onCellJobNoClick(e, uuid) {
      stopBubble(e)
      const row = this.jobs.find(row => row.uuid === uuid)
      if (!row) {
        return
      }
      if (row.lob === 'SE') {
        if (this.tenantInstructions && this.tenantInstructions.length > 0 && row.instructionUuids && row.instructionUuids.length > 0) {
          const jumpInstructions = this.tenantInstructions.filter(tenantInstruction => row.instructionUuids.indexOf(tenantInstruction.uuid) > -1 &&
            tenantInstruction.platformInstructionCode === PLATFORM_INSTRUCTION_CODE_JUMP_PAGE.code && tenantInstruction.instructionRuleJson.clickJobNoJumpPage)
          if (jumpInstructions && jumpInstructions.length === 1) {
            this.instructionClick(jumpInstructions[0], [row], INSTRUCTION_ACTION_SINGLE.code)
            return
          }
        }
        if (this.$checkPermission(['module_fmBookingNew'])) {
          const currentOfficeId = this.$store.getters.currentOfficeId
          const location = { name: 'SeaBooking', query: { currentOfficeId, jobNo: row.jobNo }, params: { branchId: currentOfficeId }}
          this.$router.push(location)
        } else {
          this.$message.error(this.$t('Message.YouToOpenTheModule', [this.$t('CargoMsg.Cargo_SeaBooking')]))
        }
      }
    },
    onLobInput(value) {
      this.lob = value
      this.jobs = []
      this.selectedRowsCount = 0
      this.selectedRow = {}
    },
    onCollapseListChange() {
      LocalStorageUtilsNew.setConfiguration('SopWorkTaskBoard_collapseList_' + this.lob, this.collapseList)
      // 确保所有节点展开或者折叠
      this.gridApi?.forEachNode(node => {
        node.setExpanded(!this.collapseList)
      })
      if (this.lob === 'SE') {
        this.se.gridOptions.groupDefaultExpanded = this.collapseList ? 0 : 2
      }
    },
    onOnlyShowSlaveChange() {
      LocalStorageUtilsNew.setConfiguration('SopWorkTaskBoard_onlyShowSlave_' + this.lob, this.onlyShowSlave)
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    }
  }
}
</script>
<style lang="scss">
.sop-work-task-board {
  .sop-tab {
    .tab-pane-wrapper {
      width: 100%;
      .tab-guide-item {
        width: 35px;
        height: 35px;
        background: #d7f5ff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        .svg-common {
          width: 17px;
          height: 17px;
          margin-right: 0px;
          color: #1F75D5;
        }
      }
      .node-selected {
        border-color: #3473b4;
        border-width: 2px;
        padding: 9px;
      }
      .node-default {
        border-color: #bad7ed;
        border-width: 1px;
        padding: 10px;
      }
    }
  }
  .select-data {
    border: 2px solid #006EBE;
    padding: 5px;
    margin-right: 5px;
    color: #006EBE;
    cursor: pointer;
    border-radius: 5px;
    user-select: none; /* 阻止文本被选中和复制 */
  }
  .no-select-data {
    border: 2px solid black;
    padding: 5px;
    margin-right: 5px;
    color: black;
    cursor: pointer;
    border-radius: 5px;
    user-select: none; /* 阻止文本被选中和复制 */
  }
  .underline-on-hover:hover {
    text-decoration: underline;
  }
  .el-divider--horizontal {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>
